import { amazonV2Translations } from "./amazonV2Translations";

export const customerGermanTranslations: Record<string, string> = {
  "Bu Amazon siparişi henüz gönderime uygun değil.": "Diese Amazon-Bestellung ist noch nicht versandbereit.",
  "Amazon V1 artık yeni sipariş almıyor. Amazon V2’ye bağlanın.": "Amazon V1 importiert keine neuen Bestellungen mehr. Verbinden Sie Amazon V2.",
  "Sipariş mağazası": "Bestellshop",
  "Sipariş platformu": "Bestellplattform",
  "Etiket satın alımlarında minimum ödeme tutarı KDV dahil 20 €’dur. Lütfen sepet tutarını artırın.": "Der Mindestbestellwert für Labels beträgt 20 € inklusive MwSt. Bitte erhöhen Sie den Warenkorbwert.",
  "Minimum alışveriş: KDV dahil 20 €.": "Mindestbestellwert: 20 € inklusive MwSt.",
  "Etiket oluşturma ve iptal": "Labels erstellen und stornieren",
  "Manuel krediden gönderi/iade etiketi oluşturur ve uygun etiketleri iptal eder.": "Erstellt Versand-/Retourenlabels mit manuellem Guthaben und storniert zulässige Labels.",
  "Gönderi veya iade etiketi oluşturma": "Versand- oder Retourenlabel erstellen",
  "Resmi Shopify uygulamasını kurun": "Offizielle Shopify-App installieren",
  "JTL Connect · veritabanı şifresi gerektirmez": "JTL Connect · kein Datenbankpasswort erforderlich",
  "Shopify mağazası bağla": "Shopify-Shop verbinden",
  "Yeni Shopify bağlantıları güvenli kurulum ve ücretlendirme için Shopify App Store üzerinden yapılır.": "Neue Shopify-Verbindungen erfolgen über den Shopify App Store für sichere Installation und Abrechnung.",
  "Manuel API anahtarı veya Shopify şifresi gerekmez.": "Kein manueller API-Schlüssel oder Shopify-Passwort erforderlich.",
  "Shopify mağazanızda uygulamayı kurun, Shopify planını onaylayın ve ardından KenPost hesabınızı tek tıkla bağlayın.": "Installieren Sie die App in Ihrem Shopify-Shop, bestätigen Sie den Shopify-Plan und verbinden Sie Ihr KenPost-Konto mit einem Klick.",
  "Shopify App Store'da aç": "Im Shopify App Store öffnen",
  ...amazonV2Translations.de,
  "En fazla 250 sipariş kontrol edilir; etiketler 100 etiketlik PDF dosyalarına ayrılır.": "Bis zu 250 Bestellungen können geprüft werden; die Labels werden in PDF-Dateien mit höchstens 100 Labels aufgeteilt.",
  "PDF dosyalarını indir": "PDF-Dateien herunterladen",
  "etiketi PDF dosyaları olarak tekrar indirebilirsiniz.": "Labels können erneut als PDF-Dateien heruntergeladen werden.",
  "Toplu etiket PDF dosyaları hazırlanıyor.": "Die PDF-Dateien der Sammel-Labels werden vorbereitet.",
  "Etiketler oluşturuldu fakat PDF dosyalarının tamamı hazırlanamadı. Son toplu işlemden tekrar indirmeyi deneyin.": "Die Labels wurden erstellt, aber nicht alle PDF-Dateien konnten vorbereitet werden. Versuchen Sie den Download über den letzten Sammelvorgang erneut.",
  "Takip ve gönderimi PlentyONE’a geri yaz": "Sendungsverfolgung und Versand an PlentyONE zurückschreiben",
  "Çekilecek sipariş dönemi": "Zeitraum für den Bestellimport",
  "Kaynak mağaza": "Quellshop",
  "Kaynak kanal": "Verkaufskanal",
  "Tüm": "Alle",
  "kanalları": "Kanäle",
  // Shared customer shell and dashboard
  "Sipariş alma ve kargo takibini geri yazma": "Bestellungen importieren und Sendungsverfolgung zurückschreiben",
  "PlentyONE REST API ile siparişleri alın; KenPost'ta oluşturulan kargo takip bilgisini PlentyONE'a geri yazın.":
    "Importieren Sie Bestellungen über die PlentyONE REST API und schreiben Sie die in KenPost erstellten Sendungsdaten an PlentyONE zurück.",
  "PlentyONE alan adındaki p ile başlayan sistem numarası (ör. p64513 için 64513).":
    "Die Systemnummer aus der PlentyONE-Domain (zum Beispiel 64513 für p64513).",
  "REST API erişimi olan PlentyONE kullanıcı adı.": "PlentyONE-Benutzername mit REST-API-Zugriff.",
  "PlentyONE REST API kullanıcısının şifresi.": "Passwort des PlentyONE-REST-API-Benutzers.",
  "API şifresi": "API-Passwort",
  "REST API kullanıcı adı": "REST-API-Benutzername",
  "REST API şifresi": "REST-API-Passwort",
  "Sipariş okuma ve kargo yazma yetkileri": "Berechtigungen zum Lesen von Bestellungen und Schreiben von Sendungen",
  "PlentyONE API kullanıcısının yetkilerini kontrol edin.": "Prüfen Sie die Berechtigungen des PlentyONE-API-Benutzers.",
  "System-ID ve API kullanıcı bilgilerini girin.": "Geben Sie die System-ID und die API-Zugangsdaten ein.",
  "Mağaza oluşunca ilk sipariş senkronunu başlatın.": "Starten Sie nach dem Anlegen des Shops die erste Bestellsynchronisierung.",
  "PlentyONE mağazasını bağla": "PlentyONE-Shop verbinden",
  "Paket ve gönderim kaydı": "Paket- und Sendungsdatensatz",
  "1 gün": "1 Tag",
  "Gönderilenler": "Versendet",
  "Güncelleniyor": "Wird aktualisiert",
  "Güncelle": "Aktualisieren",
  "Etiket bakiyesi yok": "Kein Label-Guthaben",
  "Bonus etiket": "Bonus-Label",
  "Bonus etiketleri nasıl kullanırım?": "Wie verwende ich Bonus-Labels?",
  "Bonus etiketler ilgili ürünün normal bakiyesine otomatik eklenir. Ayrı bir kod girmeniz veya ödeme yapmanız gerekmez; siparişten etiket oluşturduğunuzda uygun Kleinpaket, 2 kg, 5 kg ya da diğer ürün bakiyesinden otomatik kullanılır.":
    "Bonus-Labels werden automatisch dem normalen Guthaben des jeweiligen Produkts hinzugefügt. Sie müssen keinen zusätzlichen Code eingeben und keine Zahlung vornehmen; beim Erstellen eines Labels für eine Bestellung wird automatisch das passende Kleinpaket-, 2-kg-, 5-kg- oder sonstige Produktguthaben verwendet.",
  "etiket": "Label",
  "adres": "Adresse",
  "adet": "Stück",
  "iade": "Retoure",
  "Kalan etiket": "Verbleibende Labels",
  "Diğer ürünler": "Weitere Produkte",
  "Etiket kırılımı": "Label-Aufteilung",
  "Kartta ilk 3 ürün gösterilir; tüm kırılım burada.": "Auf der Karte werden die ersten 3 Produkte angezeigt; hier sehen Sie die vollständige Aufteilung.",
  "Ürün bazlı bakiye yok.": "Kein produktbezogenes Guthaben vorhanden.",
  "Veri alınamadı.": "Die Daten konnten nicht geladen werden.",
  "Telefon numarası zorunludur.": "Die Telefonnummer ist erforderlich.",
  "Müşteri seçimini temizle": "Kundenauswahl aufheben",
  "Kontrol paneli verisi alınamadı.": "Die Dashboard-Daten konnten nicht geladen werden.",
  "Mağaza, sipariş, etiket ve gönderi durumunu tek ekranda takip edin.":
    "Behalten Sie Shops, Bestellungen, Labels und Sendungen auf einer Seite im Blick.",
  "Sipariş için yeni etiket": "Neues Label für eine Bestellung",
  "Bağlantıları ve senkronu yönet": "Verbindungen und Synchronisierung verwalten",
  "Bakiye ve fiyatları kontrol et": "Guthaben und Preise prüfen",
  "Tracking ve etiket çıktıları": "Sendungsverfolgung und Label-Dateien",
  "Bugünkü çıkış": "Heutiger Versand",
  "Haftalık": "Letzte 7 Tage",
  "Son 7 gün": "Letzte 7 Tage",
  "Son 3 ay": "Letzte 3 Monate",
  "Tüm tarihler": "Alle Zeiträume",
  "Sipariş gösterim aralığı": "Anzeigezeitraum der Bestellungen",
  "Toplam etiket": "Labels insgesamt",
  "Kullanılan": "Verwendet",
  "Kullanıldı": "Verwendet",
  "Açık sipariş": "Offene Bestellungen",
  "Teslim edilen": "Zugestellt",
  "Teslim sinyali": "Zustellsignal",
  "Aktif taşıma": "Aktiver Transport",
  "Yolda paket": "Unterwegs",
  "İade paket": "Retouren",
  "Sorunlu paket": "Problematische Sendungen",
  "Müdahale gerekebilir": "Prüfung erforderlich",
  "Operasyon özeti": "Betriebsübersicht",
  "Bugün kritik uyarı görünmüyor.": "Heute liegen keine kritischen Warnungen vor.",
  "Kalan kullanılabilir": "Noch verfügbar",
  "Kontrol et": "Prüfen",
  "Stabil": "Stabil",
  "Toplam:": "Gesamt:",
  "· Kullanıldı:": "· Verwendet:",
  "· Void:": "· Storniert:",
  "TOPLAM ETIKET": "LABELS INSGESAMT",
  "KULLANILDI": "VERWENDET",
  "AÇIK SIPARIŞ": "OFFENE BESTELLUNGEN",
  "Hızlı işlemler": "Schnellaktionen",
  "En sık kullanılan müşteri akışları.": "Die am häufigsten verwendeten Kundenaktionen.",
  "İADE PAKET": "RETOUREN",
  "SORUNLU PAKET": "PROBLEMATISCHE SENDUNGEN",
  "Veriler güncelleniyor": "Daten werden aktualisiert",
  "Canlı veriler hazır": "Live-Daten sind verfügbar",
  "30.05.2026 KenPost Version 2 geçişi": "30.05.2026 Umstellung auf KenPost Version 2",
  "Müşteri, sipariş, gönderi, etiket stoğu ve sorun sinyallerini tek bakışta okuyun. Sayfa, son veriyi hızlı gösterir ve arka planda canlı sayılarla yenilenir.":
    "Überblicken Sie Kunden, Bestellungen, Sendungen, Labelbestand und Problemsignale auf einen Blick. Die Seite zeigt den letzten Stand sofort und aktualisiert die Zahlen im Hintergrund.",
  "Son 30 gün gönderi": "Sendungen der letzten 30 Tage",
  "Canlı operasyon temposu": "Aktuelles Versandvolumen",
  "Aktif müşteri": "Aktive Kunden",
  "Son 30 günde hareketli": "Aktiv in den letzten 30 Tagen",
  "Hazır etiket": "Verfügbare Labels",
  "Temiz veya kontrol bekleyen stok": "Unbenutzter oder noch zu prüfender Bestand",
  "Bugün dikkat edilecekler": "Heute zu prüfen",
  "Sorunlu paket, düşük bakiye ve bekleyen siparişleri hızlıca ayırır.":
    "Erkennen Sie problematische Sendungen, niedrige Guthaben und wartende Bestellungen sofort.",
  "Bugünkü gönderi": "Heutige Sendungen",
  "Etiket bekleyen sipariş": "Bestellungen ohne Label",
  "Düşük bakiyeli müşteri": "Kunden mit niedrigem Guthaben",
  "Son 30 gün": "Letzte 30 Tage",
  "Düşük stok ürünü": "Produkt mit niedrigem Bestand",
  "Takip olaylarını kapat": "Tracking-Ereignisse schließen",
  "DHL takip olayları": "DHL-Tracking-Ereignisse",
  "DHL takip sayfasını aç": "DHL-Sendungsverfolgung öffnen",
  "Bu takip numarası için kaydedilmiş DHL event kaydı yok.": "Für diese Trackingnummer ist kein DHL-Ereignis gespeichert.",
  "Son kontrol": "Letzte Prüfung",
  "Son event": "Letztes Ereignis",
  "Ekip Üyeleri": "Teammitglieder",
  "Fiyatlandırma": "Preisgestaltung",
  "Satın Alımlar": "Käufe",
  "Müşteri bulunamadı.": "Der Kunde wurde nicht gefunden.",

  // Shipping health
  "DHL sağlık ekranı hazır": "Die DHL-Versandstatusansicht ist bereit",
  "Gönderi ve carrier check kayıtları geldikçe alarm, oran ve müdahale listeleri otomatik dolacak.":
    "Sobald Versand- und Carrier-Prüfdaten vorliegen, werden Warnungen, Quoten und Maßnahmenlisten automatisch gefüllt.",
  "DHL gönderilerinizin teslim, yolda, geciken, sorunlu, iade ve tracking senkron durumunu tek operasyonda görün.":
    "Überblicken Sie Zustellung, Transport, Verzögerungen, Probleme, Retouren und Tracking-Synchronisierung Ihrer DHL-Sendungen an einem Ort.",
  "Bugün operasyon sağlığı": "Heutiger Betriebsstatus",
  "Çıkan kargo": "Versendete Sendungen",
  "30 günlük DHL etiketi": "DHL-Labels der letzten 30 Tage",
  "Teslim oranı": "Zustellquote",
  "İlk scan yok": "Kein erster Scan",
  "2 günü aşan kayıt": "Älter als 2 Tage",
  "Gönderi akışı": "Sendungsverlauf",
  "Etiket oluşturulduktan teslim ya da sorun sinyaline kadar DHL operasyon hunisi.":
    "DHL-Prozess vom erstellten Label bis zur Zustellung oder zu einem Problemsignal.",
  "Etiket oluşturuldu": "Label erstellt",
  "İlk carrier scan": "Erster Carrier-Scan",
  "İade / Sorunlu": "Retoure / Problem",
  "Müdahale Gerekenler": "Handlungsbedarf",
  "Günlük operasyon için ilk bakılması gereken DHL gönderileri.":
    "DHL-Sendungen, die im Tagesgeschäft zuerst geprüft werden sollten.",
  "Takip yazım hatası": "Fehler bei der Tracking-Übertragung",
  "İşaretlendi": "Markiert",
  "İşaretle": "Markieren",
  "Teslim denemesi başarısız": "Zustellversuch fehlgeschlagen",
  "Operasyon alarmı": "Betriebswarnung",
  "Carrier error, tracking yazımı veya etiket üretim hatası kontrol edilmeli.":
    "Carrier-Fehler, Tracking-Übertragung oder Label-Erstellung müssen geprüft werden.",
  "5/7 gün kuralına takılan gönderiler listelendi.": "Sendungen außerhalb der 5-/7-Tage-Regel werden aufgelistet.",
  "Pazar yeri tracking senkronu izlenmeli": "Tracking-Synchronisierung mit dem Marktplatz prüfen",
  "DHL ürün performansı": "DHL-Produktleistung",
  "Mağaza performansı": "Shop-Leistung",
  "Sorun oranı": "Problemquote",
  "Mağaza yok": "Kein Shop",
  "Platform performansı": "Plattformleistung",
  "Şehir / bölge gecikmeleri": "Verzögerungen nach Stadt / Region",
  "Risk oranı": "Risikoquote",
  "Bu dönem için karşılaştırma verisi yok.": "Für diesen Zeitraum liegen keine Vergleichsdaten vor.",
  "çıkan ·": "versendet ·",
  "sorun ·": "problematisch ·",
  "DHL carrier check, tracking senkronu ve ilk scan kayıtları geldikçe bu liste otomatik önceliklenecek.":
    "Sobald Carrier-Prüfungen, Tracking-Synchronisierung und erste Scans vorliegen, wird diese Liste automatisch priorisiert.",
  "gün": "Tage",
  "PDF indir": "PDF herunterladen",
  "SLA: 2 gün ilk scan · 5/7 gün risk": "SLA: erster Scan nach 2 Tagen · Risiko nach 5/7 Tagen",
  "Sağlık skoru": "Statusbewertung",
  "Carrier check kapsamı": "Umfang der Carrier-Prüfung",
  "Kargo sağlığı alınamadı.": "Der Versandstatus konnte nicht geladen werden.",
  "Takip senkronu başlatıldı.": "Die Tracking-Synchronisierung wurde gestartet.",
  "Takip senkronu başlatılamadı.": "Die Tracking-Synchronisierung konnte nicht gestartet werden.",
  "DHL kayıtları geldikçe teslimat, gecikme ve exception sinyalleri bu ekranda dolacak.":
    "Sobald DHL-Daten vorliegen, erscheinen hier Zustellungen, Verzögerungen und Ausnahmesignale.",
  "0 teslim": "0 zugestellt",
  "0 kargo": "0 Sendungen",
  "0 gönderi": "0 Sendungen",
  "Takip senkron": "Tracking-Synchronisierung",
  "0/0 başarılı": "0/0 erfolgreich",

  // Store list and integrations
  "Yeni mağaza bağla": "Neuen Shop verbinden",
  "Desteklenen pazar yerleri kompakt listede.": "Unterstützte Marktplätze in einer kompakten Übersicht.",
  "Sipariş alma ve takip numarası geri yazma": "Bestellungen abrufen und Trackingnummern zurückmelden",
  "Sipariş çekme ve fulfillment takibi": "Bestellungen abrufen und Fulfillment verfolgen",
  "Billbee siparişlerini içe aktarın": "Billbee-Bestellungen importieren",
  "OTTO mağaza bağlantısı": "OTTO-Shop-Verbindung",
  "About You sipariş bağlantısı": "About-You-Bestellverbindung",
  "Server link ve Shopify kaynak akışı": "Serververbindung und Shopify-Datenquelle",
  "Browser JSON sipariş kaynağı": "Browser-JSON als Bestellquelle",
  "Güvenli eBay bağlantısı": "Sichere eBay-Verbindung",
  "eBay bağlantı yetkisi sona erdi. Yeni siparişleri almak için bağlantıyı yenileyin.":
    "Die eBay-Autorisierung ist abgelaufen. Erneuern Sie die Verbindung, um neue Bestellungen abzurufen.",
  "eBay bağlantısını yenile": "eBay-Verbindung erneuern",
  "eBay bağlantısını yönet": "eBay-Verbindung verwalten",
  "Yeniden bağlantı gerekli": "Erneute Verbindung erforderlich",
  "JTL sipariş bağlantısı": "JTL-Bestellverbindung",
  "WooCommerce mağazanızı bağlayın": "WooCommerce-Shop verbinden",
  "Kaufland marketplace bağlantısı": "Kaufland-Marktplatzverbindung",
  "OpenCart mağaza bağlantısı": "OpenCart-Shop-Verbindung",
  "Desteklenen pazar yeri bulunamadı.": "Es wurde kein unterstützter Marktplatz gefunden.",
  "bağlantısını yönet": "Verbindung verwalten",
  "Mağazalar sayfasına yönlendiriliyorsunuz.": "Sie werden zur Shopseite weitergeleitet.",
  "Tarayıcı otomatik pencereyi engelledi.": "Der Browser hat das Pop-up blockiert.",
  "Yetkilendirme linkini manuel açıp onaydan sonra bu pencereye dönün.":
    "Öffnen Sie den Autorisierungslink manuell und kehren Sie nach der Freigabe in dieses Fenster zurück.",
  "Etsy hesabı ve browser profiliyle sipariş kaynağını eşleştirin.":
    "Verknüpfen Sie die Bestellquelle mit dem Etsy-Konto und dem Browserprofil.",
  "Etsy hesabını kaydet": "Etsy-Konto speichern",
  "Siparişleri çek": "Bestellungen abrufen",
  "Profil hatası": "Profilfehler",
  "Mağaza detayı": "Shopdetails",
  "Sıklık": "Häufigkeit",
  "Sıradaki": "Nächste Ausführung",
  "Mağazalar alınamadı.": "Die Shops konnten nicht geladen werden.",
  "eBay siparişleri alınamadı.": "Die eBay-Bestellungen konnten nicht geladen werden.",
  "JTL bağlantısı hazır.": "Die JTL-Verbindung ist bereit.",
  "JTL bağlantısı kontrol edilemedi.": "Die JTL-Verbindung konnte nicht geprüft werden.",
  "JTL bağlantısı test edilemedi.": "Die JTL-Verbindung konnte nicht getestet werden.",
  "JTL siparişleri alınamadı.": "Die JTL-Bestellungen konnten nicht geladen werden.",
  "Mağaza durumu güncellenemedi.": "Der Shopstatus konnte nicht aktualisiert werden.",
  "Bağlantı detayı yok": "Keine Verbindungsdetails",
  "Henüz yok": "Noch nicht vorhanden",
  "Pasifleştir": "Deaktivieren",
  "Aktifleştir": "Aktivieren",
  "Aktif": "Aktiv",
  "Siparişi olan mağazalar silinemez.": "Shops mit Bestellungen können nicht gelöscht werden.",
  "Siparişi olan mağazalar silinemez. Önce siparişleri kontrol edin.":
    "Shops mit Bestellungen können nicht gelöscht werden. Prüfen Sie zuerst die Bestellungen.",
  "Mağaza silinsin mi?": "Shop löschen?",
  "Bu işlem mağaza bağlantısını kapatır. Sipariş içeren mağazalar silinemez.":
    "Dadurch wird die Shop-Verbindung getrennt. Shops mit Bestellungen können nicht gelöscht werden.",
  "Mağazayı sil": "Shop löschen",
  "Mağaza silinemedi.": "Der Shop konnte nicht gelöscht werden.",
  "Amazon mağaza adı gerekli.": "Der Amazon-Shopname ist erforderlich.",
  "Amazon durumu alınamadı.": "Der Amazon-Status konnte nicht geladen werden.",
  "Amazon bağlantısı başlatılamadı.": "Die Amazon-Verbindung konnte nicht gestartet werden.",
  "Tamamlanacak aktif Amazon yetkilendirme işi bulunamadı.": "Es wurde keine offene Amazon-Autorisierung gefunden.",
  "Amazon bağlantısı tamamlanamadı.": "Die Amazon-Verbindung konnte nicht abgeschlossen werden.",
  "Kapatılacak Amazon mağazası bulunamadı.": "Es wurde kein zu trennender Amazon-Shop gefunden.",
  "Amazon bağlantısı kapatılamadı.": "Die Amazon-Verbindung konnte nicht getrennt werden.",
  "Amazon ara servisine ulaşılamıyor.": "Der Amazon-Verbindungsdienst ist nicht erreichbar.",
  "Amazon bağlantısı hazırlanıyor": "Amazon-Verbindung wird vorbereitet",
  "Yetkilendirme linki server tarafında hazırlanıyor. Açılan sekme birazdan Amazon onay ekranına yönlenecek; lütfen bu ekranı kapatmayın.":
    "Der Autorisierungslink wird auf dem Server vorbereitet. Der neue Tab leitet gleich zur Amazon-Freigabe weiter; bitte schließen Sie ihn nicht.",
  "Amazon yetkilendirme penceresi açıldı. Onaydan sonra buradan tamamlayın.":
    "Das Amazon-Autorisierungsfenster wurde geöffnet. Schließen Sie die Verbindung nach der Freigabe hier ab.",
  "Yetkilendirme bağlantısı hazır; aşağıdaki bağlantıdan açın.": "Der Autorisierungslink ist bereit; öffnen Sie ihn über den Link unten.",
  "Amazon bağlantı işi başlatıldı, fakat yetkilendirme URL'i dönmedi.":
    "Die Amazon-Verbindung wurde gestartet, aber es wurde keine Autorisierungs-URL zurückgegeben.",
  "Amazon bağlantısı tamamlandı.": "Die Amazon-Verbindung wurde abgeschlossen.",
  "Amazon bağlantısı başarıyla tamamlandı. Mağazalar sayfasına yönlendiriliyorsunuz.":
    "Die Amazon-Verbindung wurde erfolgreich abgeschlossen. Sie werden zur Shopseite weitergeleitet.",
  "Amazon bağlantısı aktif. Bu mağaza artık sipariş senkronu için hazır.":
    "Die Amazon-Verbindung ist aktiv. Dieser Shop ist jetzt für die Bestellsynchronisierung bereit.",
  "Amazon bağlantısı gönderildi; durum bridge tarafında bekliyor.":
    "Die Amazon-Verbindung wurde übermittelt; die Bestätigung des Verbindungsdienstes steht noch aus.",
  "Amazon onayı bekleniyor": "Amazon-Freigabe ausstehend",
  "Amazon penceresinde onayı tamamlayıp süre bitmeden bu ekrandan bağlantıyı tamamlayın.":
    "Bestätigen Sie den Zugriff im Amazon-Fenster und schließen Sie die Verbindung hier vor Ablauf der Frist ab.",
  "Amazon yetkilendirme süresi doldu. Lütfen bağlantıyı yeniden başlatın.":
    "Die Amazon-Autorisierung ist abgelaufen. Bitte starten Sie die Verbindung erneut.",
  "Amazon yetkilendirme süresi doldu": "Amazon-Autorisierung abgelaufen",
  "Bu onay linki artık güvenli şekilde kullanılamaz. Yeni bir yetkilendirme bağlantısı başlatın.":
    "Dieser Freigabelink kann nicht mehr sicher verwendet werden. Starten Sie eine neue Autorisierung.",
  "Yeni Amazon bağlantısı başlat": "Neue Amazon-Verbindung starten",
  "Amazon bağlantısı kapatıldı.": "Die Amazon-Verbindung wurde getrennt.",
  "Henüz Amazon mağazası oluşmadı.": "Es wurde noch kein Amazon-Shop erstellt.",
  "Etsy mağaza adı gerekli.": "Der Etsy-Shopname ist erforderlich.",
  "Etsy durumu alınamadı.": "Der Etsy-Status konnte nicht geladen werden.",
  "Etsy bağlantısı başlatılamadı.": "Die Etsy-Verbindung konnte nicht gestartet werden.",
  "Tamamlanacak aktif Etsy yetkilendirme işi bulunamadı.": "Es wurde keine offene Etsy-Autorisierung gefunden.",
  "Etsy bağlantısı tamamlanamadı.": "Die Etsy-Verbindung konnte nicht abgeschlossen werden.",
  "Kapatılacak Etsy mağazası bulunamadı.": "Es wurde kein zu trennender Etsy-Shop gefunden.",
  "Etsy bağlantısı kapatılamadı.": "Die Etsy-Verbindung konnte nicht getrennt werden.",
  "Etsy ara servisine ulaşılamıyor.": "Der Etsy-Verbindungsdienst ist nicht erreichbar.",
  "Etsy bağlantısı hazırlanıyor": "Etsy-Verbindung wird vorbereitet",
  "Yetkilendirme linki server tarafında hazırlanıyor. Açılan sekme birazdan Etsy onay ekranına yönlenecek; lütfen bu ekranı kapatmayın.":
    "Der Autorisierungslink wird auf dem Server vorbereitet. Der neue Tab leitet gleich zur Etsy-Freigabe weiter; bitte schließen Sie ihn nicht.",
  "Etsy yetkilendirme penceresi açıldı. Onaydan sonra buradan tamamlayın.":
    "Das Etsy-Autorisierungsfenster wurde geöffnet. Schließen Sie die Verbindung nach der Freigabe hier ab.",
  "Etsy bağlantı işi başlatıldı, fakat yetkilendirme URL'i dönmedi.":
    "Die Etsy-Verbindung wurde gestartet, aber es wurde keine Autorisierungs-URL zurückgegeben.",
  "Etsy bağlantısı tamamlandı.": "Die Etsy-Verbindung wurde abgeschlossen.",
  "Etsy bağlantısı başarıyla tamamlandı. Mağazalar sayfasına yönlendiriliyorsunuz.":
    "Die Etsy-Verbindung wurde erfolgreich abgeschlossen. Sie werden zur Shopseite weitergeleitet.",
  "Etsy bağlantısı aktif. Bu mağaza artık sipariş senkronu için hazır.":
    "Die Etsy-Verbindung ist aktiv. Dieser Shop ist jetzt für die Bestellsynchronisierung bereit.",
  "Etsy bağlantısı gönderildi; durum bridge tarafında bekliyor.":
    "Die Etsy-Verbindung wurde übermittelt; die Bestätigung des Verbindungsdienstes steht noch aus.",
  "Etsy onayı bekleniyor": "Etsy-Freigabe ausstehend",
  "Etsy penceresinde onayı tamamlayıp süre bitmeden bu ekrandan bağlantıyı tamamlayın.":
    "Bestätigen Sie den Zugriff im Etsy-Fenster und schließen Sie die Verbindung hier vor Ablauf der Frist ab.",
  "Etsy yetkilendirme süresi doldu. Lütfen bağlantıyı yeniden başlatın.":
    "Die Etsy-Autorisierung ist abgelaufen. Bitte starten Sie die Verbindung erneut.",
  "Etsy yetkilendirme süresi doldu": "Etsy-Autorisierung abgelaufen",
  "Yeni Etsy bağlantısı başlat": "Neue Etsy-Verbindung starten",
  "Etsy bağlantısı kapatıldı.": "Die Etsy-Verbindung wurde getrennt.",
  "Henüz Etsy mağazası oluşmadı.": "Es wurde noch kein Etsy-Shop erstellt.",
  "Amazon ile aynı Salestio bridge senaryosuyla Etsy hesabını ekler.":
    "Verbindet das Etsy-Konto über denselben Salestio-Verbindungsablauf wie Amazon.",
  "Bağlantı kapatılınca bu mağaza için otomatik sipariş senkronu durur.":
    "Beim Trennen der Verbindung wird die automatische Bestellsynchronisierung für diesen Shop beendet.",
  "Yarım kalan bağlantı kapatılacak ve yeni mağaza bağlantısı için ekran temizlenecek.":
    "Die unvollständige Verbindung wird beendet und die Ansicht für eine neue Shop-Verbindung zurückgesetzt.",
  "Yeni mağaza bağlantısı için ekran temizlenecek.": "Die Ansicht wird für eine neue Shop-Verbindung zurückgesetzt.",
  "Aktif hale gelmiş mağazalara dokunulmaz; sadece yarım kalmış yetkilendirme işi temizlenir.":
    "Aktive Shops bleiben unverändert; nur der unvollständige Autorisierungsvorgang wird entfernt.",
  "Baştan başlat": "Neu starten",
  "Meşgul": "Beschäftigt",
  "Ulaşılamıyor": "Nicht erreichbar",
  "Bağlı": "Verbunden",
  "Yeni": "Neu",
  "Kalan süre": "Verbleibende Zeit",
  "Süre doldu": "Abgelaufen",
  "Yetkilendirme penceresinde onayı tamamladıktan sonra bağlantıyı buradan tamamlayın.":
    "Schließen Sie die Verbindung hier ab, nachdem Sie die Freigabe im Autorisierungsfenster bestätigt haben.",
  "Bağlantı tamamla penceresini kapat": "Fenster zum Abschließen der Verbindung schließen",
  "Süre": "Dauer",
  "Etsy hesabı kaydedildi.": "Das Etsy-Konto wurde gespeichert.",
  "Etsy hesabı kaydedilemedi.": "Das Etsy-Konto konnte nicht gespeichert werden.",
  "Önce Etsy hesabını kaydedin.": "Speichern Sie zuerst das Etsy-Konto.",
  "Etsy siparişleri çekilemedi.": "Die Etsy-Bestellungen konnten nicht abgerufen werden.",
  "Etsy bağlantısı kapatılsın mı?": "Etsy-Verbindung trennen?",
  "Otomatik Etsy sipariş senkronu durur.": "Die automatische Etsy-Bestellsynchronisierung wird beendet.",
  "Bu bilgiler KenPost tarafında saklanır; server profili hazır olduğunda siparişler JSON kaynağından alınır.":
    "Diese Angaben werden in KenPost gespeichert; sobald das Serverprofil bereit ist, werden Bestellungen aus der JSON-Quelle abgerufen.",
  "Etsy kullanıcı adı / e-posta": "Etsy-Benutzername / E-Mail",
  "Etsy şifre": "Etsy-Passwort",
  "JSON kaynağı": "JSON-Quelle",
  "Ulaşılıyor": "Erreichbar",
  "Kaynak çalışması": "Quellstatus",
  "Kaynak sipariş": "Bestellungen der Quelle",
  "Son KenPost sync": "Letzte KenPost-Synchronisierung",
  "KenPost sipariş": "KenPost-Bestellungen",
  "Profil hazır değil.": "Das Profil ist noch nicht bereit.",
  "Admin sayfa kontrolü": "Prüfung der Adminseite",
  "Senkron logları alınamadı.": "Die Synchronisierungsprotokolle konnten nicht geladen werden.",
  "Senkron logları yükleniyor": "Synchronisierungsprotokolle werden geladen",
  "Senkron logları": "Synchronisierungsprotokolle",
  "Mağaza senkron geçmişi": "Synchronisierungsverlauf des Shops",
  "Son durum": "Letzter Status",
  "Toplam log": "Protokolle insgesamt",
  "Pasif mağazalar otomatik kontrolde denenmez.": "Inaktive Shops werden bei der automatischen Prüfung übersprungen.",
  "Kapalı": "Deaktiviert",
  "Log kayıtları": "Protokolleinträge",
  "Henüz senkron logu yok.": "Noch keine Synchronisierungsprotokolle vorhanden.",
  "Tür": "Typ",
  "Sonuç": "Ergebnis",
  "Admin kullanıcı adı": "Admin-Benutzername",
  "Admin şifre": "Admin-Passwort",
  "Mağaza oluşturulamadı.": "Der Shop konnte nicht erstellt werden.",
  "Platform Bağlantısı": "Plattformverbindung",
  "Önerilen yöntem; client bilgileriyle çalışır.": "Empfohlene Methode; verwendet die Client-Zugangsdaten.",
  "IP / DB Bağlantısı": "IP-/Datenbankverbindung",
  "Özel JTL kurulumları için gelişmiş alanlar.": "Erweiterte Felder für spezielle JTL-Installationen.",
  "API anahtarı / Beyaz IP": "API-Schlüssel / freigegebene IP",
  "OpenCart API kullanıcı adı ve anahtarıyla çalışır; gerekiyorsa sabit IP relay kullanılır.":
    "Verwendet OpenCart-API-Benutzername und -Schlüssel; bei Bedarf wird eine feste IP-Weiterleitung eingesetzt.",
  "Admin erişimi": "Admin-Zugriff",
  "Sipariş listesini admin panelinden okumak için kullanıcı adı ve şifre kullanır.":
    "Verwendet Benutzername und Passwort, um die Bestellliste aus dem Adminbereich zu lesen.",
  "Bağlantı profili": "Verbindungsprofil",
  "Platforma göre gerekli alanlar ve çalışma biçimi ayrıştırıldı.":
    "Erforderliche Felder und Arbeitsweise sind auf die Plattform abgestimmt.",
  "Kurulum akışı": "Einrichtungsablauf",
  "Bu mağaza özel gönderici adresi kullanıyor": "Dieser Shop verwendet eine eigene Absenderadresse",
  "Bu mağaza genel profil adresini kullanıyor": "Dieser Shop verwendet die allgemeine Profiladresse",
  "Mağaza gönderici adresi": "Absenderadresse des Shops",
  "Varsayılan olarak profilinizdeki genel gönderici adresi kullanılır; sadece bu mağaza farklı adresten gönderiyorsa özel adres tanımlayın.":
    "Standardmäßig wird die allgemeine Absenderadresse Ihres Profils verwendet. Hinterlegen Sie nur dann eine eigene Adresse, wenn dieser Shop von einer anderen Adresse versendet.",
  "Mağaza özel adresi": "Eigene Shopadresse",
  "Varsayılan genel adres": "Allgemeine Standardadresse",
  "Gönderici adı eksik": "Absendername fehlt",
  "Özel adresi değiştir": "Eigene Adresse ändern",
  "Bu mağaza için farklı adres kullan": "Andere Adresse für diesen Shop verwenden",
  "Özel gönderici adresini değiştir": "Eigene Absenderadresse ändern",
  "Mağazaya özel gönderici adresi tanımla": "Eigene Absenderadresse für den Shop hinterlegen",
  "Mağaza detayı alınamadı.": "Die Shopdetails konnten nicht geladen werden.",
  "Mağaza özel gönderici adresi aktif edildi.": "Die eigene Absenderadresse des Shops wurde aktiviert.",
  "Mağaza gönderici adresi kaydedilemedi.": "Die Absenderadresse des Shops konnte nicht gespeichert werden.",
  "Genel gönderici adresine dönülsün mü?": "Zur allgemeinen Absenderadresse zurückkehren?",
  "Etiketler bundan sonra profilinizdeki genel gönderici adresini kullanır.":
    "Labels verwenden künftig die allgemeine Absenderadresse Ihres Profils.",
  "Genel adrese dön": "Allgemeine Adresse verwenden",
  "Mağaza yeniden genel gönderici adresini kullanıyor.": "Der Shop verwendet wieder die allgemeine Absenderadresse.",
  "Genel gönderici adresine dönülemedi.": "Die allgemeine Absenderadresse konnte nicht wiederhergestellt werden.",
  "Seçilen mağaza gönderici adresi aktif edildi.": "Die ausgewählte Shop-Absenderadresse wurde aktiviert.",
  "Mağaza gönderici adresi aktif edilemedi.": "Die Shop-Absenderadresse konnte nicht aktiviert werden.",
  "Mağaza ayarları güncellendi.": "Die Shopeinstellungen wurden aktualisiert.",
  "Mağaza güncellenemedi.": "Der Shop konnte nicht aktualisiert werden.",
  "Sipariş senkronu tamamlanamadı.": "Die Bestellsynchronisierung konnte nicht abgeschlossen werden.",
  "Bağlantı bilgisi yok": "Keine Verbindungsdaten",
  "Kayıtlı. Değiştirmek için yeni değer girin.": "Gespeichert. Geben Sie zum Ändern einen neuen Wert ein.",
  "Onboarding bilgisi alınamadı.": "Die Einrichtungsdaten konnten nicht geladen werden.",
  "İlk mağazanızı bağlayın.": "Verbinden Sie Ihren ersten Shop.",
  "son 3 gün": "letzte 3 Tage",
  "son 1 gün": "letzter Tag",
  "son 7 gün": "letzte 7 Tage",
  "son 30 gün": "letzte 30 Tage",
  "son 3 ay": "letzte 3 Monate",
  "tüm dönem": "gesamter Zeitraum",

  // Store connection forms
  "Mağaza bilgilerini ekleyin; sipariş senkronu mağaza kaydından sonra yönetilir.":
    "Fügen Sie die Shopdaten hinzu; die Bestellsynchronisierung wird nach dem Speichern des Shops verwaltet.",
  "Platform bağlantı bilgisi": "Zugangsdaten der Plattform",
  "Mağaza adını girin.": "Geben Sie den Shopnamen ein.",
  "Mağazayı oluşturup ilk senkronu başlatın.": "Erstellen Sie den Shop und starten Sie die erste Synchronisierung.",
  "İsteğe bağlı": "Optional",
  "Afterbuy XML arayüzüyle siparişlerinizi alın ve oluşturulan takip numaralarını Afterbuy'a geri yazın.":
    "Rufen Sie Bestellungen über die Afterbuy-XML-Schnittstelle ab und übertragen Sie erstellte Trackingnummern zurück an Afterbuy.",
  "Afterbuy hesabında görünen kullanıcı/hesap adı.": "Der in Afterbuy angezeigte Benutzer- bzw. Kontoname.",
  "KenPost için oluşturulan XML-Schnittstelle PartnerToken değeri.": "Der für KenPost erstellte PartnerToken der XML-Schnittstelle.",
  "Afterbuy ekranında UserToken veya AccountToken olarak gösterilen değer.":
    "Der in Afterbuy als UserToken oder AccountToken angezeigte Wert.",
  "ör. bucomberlin": "z. B. bucomberlin",
  "Afterbuy hesap adı": "Afterbuy-Kontoname",
  "Afterbuy'da XML-Schnittstelle erişimini açın.": "Aktivieren Sie in Afterbuy den Zugriff auf die XML-Schnittstelle.",
  "KenPost için verilen tokenları girin.": "Geben Sie die für KenPost bereitgestellten Token ein.",
  "Bağlantı doğrulandıktan sonra ilk sipariş senkronunu başlatın.":
    "Starten Sie nach erfolgreicher Verbindungsprüfung die erste Bestellsynchronisierung.",
  "Afterbuy mağazasını bağla": "Afterbuy-Shop verbinden",
  "Afterbuy fatura otomasyonunu tetikle": "Afterbuy-Rechnungsautomatik auslösen",
  "Afterbuy yerel fatura akışı": "Nativer Afterbuy-Rechnungsablauf",
  "Takip numarası yazıldıktan sonra bu TAG mevcut TAG'ler korunarak Afterbuy siparişine eklenir. Faturayı ve PDF e-postasını Afterbuy'ın kendi iş akışı oluşturur; KenPost fatura numarası ile tarihini doğruladıktan sonra siparişi çalışma listesinden gizler. Amazon siparişleri hesap güvenliği için bu fatura e-posta tetikleyicisinden kesin olarak hariç tutulur.":
    "Nach dem Eintragen der Sendungsnummer wird dieser Tag zur Afterbuy-Bestellung hinzugefügt, ohne vorhandene Tags zu verändern. Der native Afterbuy-Workflow erstellt die Rechnung und versendet die PDF per E-Mail; KenPost blendet die Bestellung erst nach Prüfung von Rechnungsnummer und Rechnungsdatum aus der Arbeitsliste aus. Amazon-Bestellungen sind zum Schutz des Amazon-Kontos vollständig von diesem Rechnungs-E-Mail-Auslöser ausgeschlossen.",
  "Tetik TAG'i": "Auslöser-Tag",
  "Bu TAG, Afterbuy TAG Manager'da yalnız KenPost fatura iş akışı için oluşturulmalı ve Workflow Manager filtresinde aynı adla seçilmelidir.":
    "Legen Sie diesen Tag im Afterbuy Tag Manager ausschließlich für den KenPost-Rechnungsworkflow an und wählen Sie im Filter des Workflow Managers exakt denselben Namen aus.",
  "Otomatik senkron": "Automatische Synchronisierung",
  "Bu form mevcut KenPost müşteri panelindeki eski harici Shopify connector akışı içindir. App Store'daki KenPost Billing Bridge Shopify Admin içinde kurulum izinleri, App Bridge ve Shopify API ile çalışır.":
    "Dieses Formular ist für die bestehende externe Shopify-Verbindung im KenPost-Kundenbereich vorgesehen. Die KenPost Billing Bridge aus dem App Store verwendet Installationsberechtigungen, App Bridge und die Shopify API innerhalb von Shopify Admin.",
  "Örnek: mystore.myshopify.com": "Beispiel: mystore.myshopify.com",
  "Mevcut müşteri connector erişim bilgisi. Orders ve fulfillment izinleri açık olmalı.":
    "Zugangsdaten der bestehenden Kundenverbindung. Berechtigungen für Bestellungen und Fulfillment müssen aktiviert sein.",
  "Connector erişim bilgisi": "Zugangsdaten der Verbindung",
  "Bu form yalnızca mevcut KenPost müşteri connector'ı içindir":
    "Dieses Formular ist ausschließlich für die bestehende KenPost-Kundenverbindung vorgesehen",
  "KenPost müşteri panelindeki harici connector için mağaza erişim bilgisini hazırlayın.":
    "Bereiten Sie die Shop-Zugangsdaten für die externe Verbindung im KenPost-Kundenbereich vor.",
  "Domain ve erişim bilgisini bu forma girin.": "Tragen Sie Domain und Zugangsdaten in dieses Formular ein.",
  "Mağaza oluşunca sipariş senkronunu başlatın.": "Starten Sie nach dem Erstellen des Shops die Bestellsynchronisierung.",
  "Shopify mağazasını bağla": "Shopify-Shop verbinden",
  "Billbee API bilgileriyle siparişlerinizi içe aktarın ve mağaza bazlı senkron yönetin.":
    "Importieren Sie Bestellungen mit den Billbee-API-Daten und verwalten Sie die Synchronisierung je Shop.",
  "Panelde görünecek Billbee bağlantı adı.": "Der im Kundenbereich angezeigte Name der Billbee-Verbindung.",
  "Billbee API anahtarı.": "Billbee-API-Schlüssel.",
  "Billbee API kullanıcı adı.": "Billbee-API-Benutzername.",
  "Billbee API şifresi.": "Billbee-API-Passwort.",
  "Billbee bağlantı adı": "Name der Billbee-Verbindung",
  "Billbee API erişimini açın.": "Aktivieren Sie den Billbee-API-Zugriff.",
  "API key ve kullanıcı bilgilerini girin.": "Geben Sie API-Schlüssel und Benutzerdaten ein.",
  "Mağazayı oluşturup siparişleri senkronlayın.": "Erstellen Sie den Shop und synchronisieren Sie die Bestellungen.",
  "Billbee mağazasını bağla": "Billbee-Shop verbinden",
  "İçe aktarım": "Import",
  "About You bağlantısını API key ile ekleyin; sipariş çekme akışı mağaza ekranından çalışır.":
    "Fügen Sie die About-You-Verbindung mit dem API-Schlüssel hinzu; Bestellungen werden über die Shopansicht abgerufen.",
  "About You adı": "About-You-Name",
  "API erişim bilgisini hazırlayın.": "Bereiten Sie die API-Zugangsdaten vor.",
  "Bağlantı adı ve API key bilgisini girin.": "Geben Sie Verbindungsname und API-Schlüssel ein.",
  "Mağazayı oluşturun.": "Erstellen Sie den Shop.",
  "About You mağazasını bağla": "About-You-Shop verbinden",
  "Senkron": "Synchronisierung",
  "OTTO Partner Connect client bilgileriyle mağaza bağlantısını oluşturun.":
    "Erstellen Sie die Shop-Verbindung mit den Client-Daten von OTTO Partner Connect.",
  "Müşterinin göreceği OTTO mağaza adı.": "Der OTTO-Shopname, der dem Kunden angezeigt wird.",
  "OTTO mağaza adı": "OTTO-Shopname",
  "OTTO Partner Connect hesabında client bilgilerini açın.": "Öffnen Sie die Client-Daten im OTTO-Partner-Connect-Konto.",
  "Client ID ve Secret alanlarını doldurun.": "Füllen Sie Client-ID und Client-Secret aus.",
  "Mağazayı oluşturup senkronu çalıştırın.": "Erstellen Sie den Shop und starten Sie die Synchronisierung.",
  "OTTO mağazasını bağla": "OTTO-Shop verbinden",
  "Sipariş API": "Bestell-API",
  "JTL için platform bağlantısı önceliklidir; IP/DB modu yalnızca özel kurulumlarda kullanılır.":
    "Für JTL wird die Plattformverbindung empfohlen; der IP-/Datenbankmodus ist nur für spezielle Installationen vorgesehen.",
  "JTL bağlantı URL'i. Örnek: https://shop.example.com": "URL der JTL-Verbindung. Beispiel: https://shop.example.com",
  "JTL platform bağlantısı Client ID.": "Client-ID der JTL-Plattformverbindung.",
  "JTL platform bağlantısı Client Secret.": "Client-Secret der JTL-Plattformverbindung.",
  "Yalnızca IP/DB kurulumunda gerekli.": "Nur für eine IP-/Datenbankinstallation erforderlich.",
  "JTL veritabanı adı.": "Name der JTL-Datenbank.",
  "Veritabanı kullanıcısı.": "Datenbankbenutzer.",
  "Veritabanı şifresi.": "Datenbankpasswort.",
  "Önce Platform Bağlantısı modunu deneyin.": "Verwenden Sie zunächst den Modus Plattformverbindung.",
  "Özel kurulum gerekiyorsa IP/DB modunu seçin.": "Wählen Sie bei einer speziellen Installation den IP-/Datenbankmodus.",
  "Mağaza oluşunca bağlantıyı test edin.": "Testen Sie die Verbindung nach dem Erstellen des Shops.",
  "JTL mağazasını bağla": "JTL-Shop verbinden",
  "JTL senkron": "JTL-Synchronisierung",
  "Panel bağlantısı": "Panelverbindung",
  "JTL bağlantı modu": "JTL-Verbindungsmodus",
  "WooCommerce REST API anahtarlarıyla mağazanızı bağlayın.": "Verbinden Sie Ihren Shop mit WooCommerce-REST-API-Schlüsseln.",
  "WooCommerce REST API anahtarlarını oluşturun.": "Erstellen Sie die WooCommerce-REST-API-Schlüssel.",
  "URL ve anahtarları girin.": "Geben Sie URL und Schlüssel ein.",
  "Mağazayı oluşturup siparişleri çekin.": "Erstellen Sie den Shop und rufen Sie die Bestellungen ab.",
  "WooCommerce mağazasını bağla": "WooCommerce-Shop verbinden",
  "Yalnızca seçili ülkenin siparişlerini getir": "Nur Bestellungen aus dem ausgewählten Land abrufen",
  "Kapalıyken WooCommerce mağazasındaki tüm ülkelerin siparişleri alınır.":
    "Wenn diese Option deaktiviert ist, werden Bestellungen aus allen Ländern des WooCommerce-Shops abgerufen.",
  "Sipariş ülkesi": "Bestellland",
  "Kaufland marketplace bağlantısı için client key ve secret bilgilerini girin.":
    "Geben Sie Client-Key und Secret für die Kaufland-Marktplatzverbindung ein.",
  "Kaufland API credentials alanından key alın.": "Rufen Sie den Schlüssel im Bereich Kaufland API Credentials ab.",
  "Storefront değerini kontrol edin.": "Prüfen Sie den Storefront-Wert.",
  "Mağaza kaydını oluşturun.": "Erstellen Sie den Shopeintrag.",
  "Kaufland mağazasını bağla": "Kaufland-Shop verbinden",
  "OpenCart mağazanızı admin erişimi veya API anahtarı/beyaz IP yöntemiyle bağlayın.":
    "Verbinden Sie Ihren OpenCart-Shop per Adminzugriff oder API-Schlüssel mit freigegebener IP.",
  "API modu için mağaza URL'i de yeterlidir; admin modu için /admin adresini girin. Örnek: https://site.com/admin":
    "Im API-Modus genügt die Shop-URL; geben Sie im Adminmodus die /admin-Adresse ein. Beispiel: https://site.com/admin",
  "API modunda OpenCart API kullanıcı adı; admin modunda admin kullanıcısı.":
    "Im API-Modus der OpenCart-API-Benutzername, im Adminmodus der Adminbenutzer.",
  "API modunda OpenCart API anahtarı; admin modunda admin şifresi.":
    "Im API-Modus der OpenCart-API-Schlüssel, im Adminmodus das Adminpasswort.",
  "API kullanıcı adı": "API-Benutzername",
  "API anahtarı veya admin şifresi": "API-Schlüssel oder Adminpasswort",
  "Mağaza/Admin URL": "Shop-/Admin-URL",
  "Mağaza / Admin URL": "Shop-/Admin-URL",
  "API kullanıcı adı veya admin kullanıcı": "API-Benutzername oder Adminbenutzer",
  "API anahtarı veya admin şifre": "API-Schlüssel oder Adminpasswort",
  "Önce API anahtarı / beyaz IP modunu deneyin.": "Verwenden Sie zunächst den Modus API-Schlüssel / freigegebene IP.",
  "OpenCart API kullanıcısı ve anahtarı girin.": "Geben Sie OpenCart-API-Benutzer und -Schlüssel ein.",
  "Sipariş listesi için admin erişimi gerekiyorsa admin moduna geçin.":
    "Wechseln Sie in den Adminmodus, wenn für die Bestellliste ein Adminzugriff erforderlich ist.",
  "OpenCart mağazasını bağla": "OpenCart-Shop verbinden",
  "OpenCart senkron": "OpenCart-Synchronisierung",
  "OpenCart bağlantı modu": "OpenCart-Verbindungsmodus",
  "Zurück zu den Geschäften": "Zurück zu den Shops",
  "Manuel": "Manuell",
  "Panelden": "Über das Panel",
  "OPSIYONEL": "OPTIONAL",
  "Opsiyonel": "Optional",
  "Gerekli bilgiler": "Erforderliche Angaben",
  "Platform bilgilerini doldurun.": "Geben Sie die Plattformdaten ein.",
  "Afterbuy'a geri yazma": "An Afterbuy zurückmelden",
  "Orders okuma izni": "Berechtigung zum Lesen von Bestellungen",
  "Fulfillment geri yazma izni": "Berechtigung zum Zurückschreiben von Fulfillments",
  "Varsa uygulama/client ID bilgisini ekleyin.": "Fügen Sie, falls vorhanden, die App-/Client-ID hinzu.",
  "KenPost Billing Bridge runs inside Shopify Admin.": "KenPost Billing Bridge wird innerhalb von Shopify Admin ausgeführt.",
  "The Shopify App Store app home uses installed app permissions, App Bridge session tokens, token exchange, and Shopify Admin API. This customer connector form is only for existing KenPost account integrations.":
    "Die Startseite der Shopify-App verwendet die installierten App-Berechtigungen, App-Bridge-Sitzungstoken, Token-Austausch und die Shopify Admin API. Dieses Kunden-Verbindungsformular ist nur für bestehende KenPost-Kontointegrationen vorgesehen.",
  "Etsy hesap bilgileri": "Etsy-Kontodaten",
  "Browser profili": "Browserprofil",
  "Browser portu": "Browserport",
  "Kaynak durumu": "Quellstatus",
  "Profil durumu": "Profilstatus",
  "Platform / IP": "Plattform / IP",
  "Kurulum": "Einrichtung",
  "KURULUM": "EINRICHTUNG",
  "Opsiyonel IP/DB bilgileri": "Optionale IP-/DB-Daten",
  "MSSQL portu. Genellikle 1433.": "MSSQL-Port. Normalerweise 1433.",
  "Vitrin": "Storefront",
  "VITRIN": "STOREFRONT",
  "Relay destekli": "Relay-unterstützt",
  "Gerekirse KenPost sabit IP whitelist": "Bei Bedarf feste KenPost-IP freigeben",
  "Genel gönderici adresi eksik. Etiket oluşturmak için profil gönderici adresini veya bu mağaza için özel adresi tamamlayın.":
    "Die allgemeine Absenderadresse fehlt. Vervollständigen Sie die Profiladresse oder eine eigene Adresse für diesen Shop, um Labels zu erstellen.",
  "Genel profil adresine dön": "Zur allgemeinen Profiladresse zurückkehren",
  "Kaydettiğiniz adres yalnızca bu mağazada etiket oluştururken kullanılır.":
    "Die gespeicherte Adresse wird nur bei der Label-Erstellung für diesen Shop verwendet.",
  "Bu mağazada özel adresi kullan": "Eigene Adresse für diesen Shop verwenden",
  "Formu boşalt": "Formular leeren",
  "Daha önce kaydedilen özel adresler": "Zuvor gespeicherte eigene Adressen",
  "Aktif yap": "Aktivieren",

  // Orders and labels
  "JTL ağırlığına göre otomatik": "Automatisch nach JTL-Gewicht",
  "Etiket ürünü seçili değil": "Kein Labelprodukt ausgewählt",
  "Sipariş destek verileri alınamadı.": "Die ergänzenden Bestelldaten konnten nicht geladen werden.",
  "Siparişler alınamadı.": "Die Bestellungen konnten nicht geladen werden.",
  "Sipariş arşivlensin mi?": "Bestellung archivieren?",
  "Arşivlenmiş siparişler görünümünden tekrar geri alınabilir.":
    "Die Bestellung kann in der Ansicht der archivierten Bestellungen wiederhergestellt werden.",
  "Arşivle": "Archivieren",
  "Arşivlenmiş siparişler": "Archivierte Bestellungen",
  "Arşivlenecek siparişleri seçin.": "Wählen Sie die zu archivierenden Bestellungen aus.",
  "Seçili siparişler arşivlensin mi?": "Ausgewählte Bestellungen archivieren?",
  "Arşivlenmiş siparişler görünümünden tek tek geri alınabilir.": "Sie können in der Ansicht der archivierten Bestellungen einzeln wiederhergestellt werden.",
  "Seçilenleri arşivle": "Auswahl archivieren",
  "Seçili siparişler arşivlenemedi.": "Die ausgewählten Bestellungen konnten nicht archiviert werden.",
  "Sipariş arşivlenemedi.": "Die Bestellung konnte nicht archiviert werden.",
  "Sipariş arşivden geri alınamadı.": "Die Bestellung konnte nicht aus dem Archiv wiederhergestellt werden.",
  "Bu sipariş": "Diese Bestellung",
  "Gönderi iptal edilemedi.": "Die Sendung konnte nicht storniert werden.",
  "Senkron için aktif mağaza bulunamadı.": "Für die Synchronisierung wurde kein aktiver Shop gefunden.",
  "Senkron tamamlanamadı.": "Die Synchronisierung konnte nicht abgeschlossen werden.",
  "Senkron başlatılamadı.": "Die Synchronisierung konnte nicht gestartet werden.",
  "Etiket oluşturmak için sipariş ve etiket ürünü gerekli.": "Für die Label-Erstellung sind eine Bestellung und ein Labelprodukt erforderlich.",
  "Etiket oluşturulamadı.": "Das Label konnte nicht erstellt werden.",
  "Etiket oluşturmadan önce ürün, kredi ve kargo adresini kontrol edin.":
    "Prüfen Sie vor der Label-Erstellung Produkt, Guthaben und Lieferadresse.",
  "Toplu etiket geçmişi alınamadı.": "Der Sammel-Label-Verlauf konnte nicht geladen werden.",
  "Toplu etiketler tek PDF olarak yeniden hazırlanıyor.": "Die Labels werden erneut als eine einzige PDF-Datei vorbereitet.",
  "Son toplu etiketler tek PDF olarak yeniden hazırlanıyor.": "Die letzten Sammel-Labels werden erneut als eine einzige PDF-Datei vorbereitet.",
  "Geçmişteki etiketler tek PDF olarak yeniden hazırlanıyor.": "Die früheren Labels werden erneut als eine einzige PDF-Datei vorbereitet.",
  "Etiketler tek PDF olarak hazırlanamadı.": "Die Labels konnten nicht als eine einzige PDF-Datei vorbereitet werden.",
  "Etiketler oluşturuldu fakat tek PDF hazırlanamadı. Son toplu işlemden tekrar indirmeyi deneyin.":
    "Die Labels wurden erstellt, aber die gemeinsame PDF-Datei konnte nicht vorbereitet werden. Versuchen Sie den Download über den letzten Sammelvorgang erneut.",
  "Seçili siparişlerin tüm etiketleri hazır olmadığı için eksik toplu PDF indirilmedi.":
    "Nicht alle ausgewählten Labels sind bereit; daher wurde keine unvollständige Sammel-PDF heruntergeladen.",
  "Toplu etiket geçmişi": "Sammel-Label-Verlauf",
  "Son toplu etiket PDF hazır": "Die letzte Sammel-PDF ist bereit",
  "Tek PDF'i indir": "Eine PDF-Datei herunterladen",
  "Tek PDF olarak indirilebilir": "Als eine PDF-Datei verfügbar",
  "Etiketler tek PDF olarak hazırlanıyor": "Die Labels werden als eine einzige PDF-Datei vorbereitet",
  "Etiketler oluşturuldu, liste ve toplu etiket geçmişi yenileniyor.":
    "Die Labels wurden erstellt; die Liste und der Sammel-Label-Verlauf werden aktualisiert.",
  "Siparişlerden oluşturulan etiketleri tek PDF olarak tekrar indirebilirsiniz.":
    "Sie können die aus Bestellungen erstellten Labels erneut als eine einzige PDF-Datei herunterladen.",
  "Toplu etiket geçmişini kapat": "Sammel-Label-Verlauf schließen",
  "Toplu etiket geçmişi yükleniyor": "Sammel-Label-Verlauf wird geladen",
  "Henüz toplu etiket kaydı yok": "Noch kein Sammel-Label-Eintrag vorhanden",
  "Siparişleri seçip toplu etiket oluşturduğunuzda PDF kayıtları burada görünür.":
    "Wenn Sie Bestellungen auswählen und Sammel-Labels erstellen, erscheinen die PDF-Einträge hier.",
  "Toplu ZIP geçmişi alınamadı.": "Der ZIP-Sammelverlauf konnte nicht geladen werden.",
  "Toplu etiket ZIP yeniden indiriliyor.": "Die Sammel-ZIP-Datei wird erneut heruntergeladen.",
  "Son toplu etiket ZIP yeniden indiriliyor.": "Die letzte Sammel-ZIP-Datei wird erneut heruntergeladen.",
  "Bu arşivde indirilebilir gönderi bulunamadı.": "Dieses Archiv enthält keine herunterladbaren Sendungen.",
  "Toplu etiket için sipariş seçin.": "Wählen Sie Bestellungen für die Sammel-Label-Erstellung aus.",
  "İade/iptal veya mevcut etiketi olan siparişler toplu etiket işleminden çıkarıldı.":
    "Stornierte bzw. retournierte Bestellungen und Bestellungen mit vorhandenem Label wurden aus der Sammelverarbeitung entfernt.",
  "Seçili siparişler bu sayfada bulunamadı. Lütfen siparişleri tekrar seçin.":
    "Die ausgewählten Bestellungen wurden auf dieser Seite nicht gefunden. Bitte wählen Sie sie erneut aus.",
  "Toplu etiket kontrolü hazırlanamadı.": "Die Prüfung der Sammel-Labels konnte nicht vorbereitet werden.",
  "Toplu etiket için hazırlanmış sipariş bulunamadı.": "Es wurden keine für Sammel-Labels vorbereiteten Bestellungen gefunden.",
  "Toplu etiket oluşturulamadı.": "Die Sammel-Labels konnten nicht erstellt werden.",
  "Toplu etiket parçası tamamlanamadı.": "Ein Teil der Sammel-Label-Erstellung konnte nicht abgeschlossen werden.",
  "sipariş hazır. En fazla": "Bestellungen sind bereit. Höchstens",
  "sipariş tek toplu işlemde sıraya alınır.": "Bestellungen werden pro Sammelvorgang eingeplant.",
  "Aktif siparişler": "Aktive Bestellungen",
  "Ürün detayları": "Artikeldetails",
  "Son toplu etiket ZIP hazır": "Die letzte Sammel-ZIP-Datei ist bereit",
  "gönderilik son toplu paketi tekrar indirebilirsiniz.": "Sendungen im letzten Sammelpaket; Sie können es erneut herunterladen.",
  "Son ZIP'i indir": "Letzte ZIP-Datei herunterladen",
  "Geçmişi aç": "Verlauf öffnen",
  "Aktif mağaza yok": "Kein aktiver Shop",
  "Tüm mağazalar senkronize ediliyor": "Alle Shops werden synchronisiert",
  "mağaza": "Shop",
  "Tüm Billbee mağazaları": "Alle Billbee-Shops",
  "seçili": "ausgewählt",
  "sipariş seçildi": "Bestellungen ausgewählt",
  "Toplu etiket kontrolü": "Prüfung der Sammel-Labels",
  "Filtreleri temizleyin, mağaza senkronu çalıştırın veya ilk mağazanızı bağlayın.":
    "Setzen Sie die Filter zurück, synchronisieren Sie einen Shop oder verbinden Sie Ihren ersten Shop.",
  "Seçili siparişlerde paket, kilo ve adres bilgisini kontrol edin; onaydan sonra etiketler sırayla oluşturulur.":
    "Prüfen Sie Paket-, Gewichts- und Adressdaten der ausgewählten Bestellungen. Nach der Bestätigung werden die Labels nacheinander erstellt.",
  "Seçili sipariş": "Ausgewählte Bestellung",
  "Henüz ürün seçilmedi": "Noch kein Produkt ausgewählt",
  "Kredi işlemi tamamlandı": "Die Guthabenverrechnung ist abgeschlossen",
  "Seçili siparişlerin etiket işlemi tamamlandı.": "Die Label-Erstellung für die ausgewählten Bestellungen ist abgeschlossen.",
  "Seçili tüm siparişlerin etiketleri zaten oluşturuldu.": "Die Labels für alle ausgewählten Bestellungen wurden bereits erstellt.",
  "Son toplu işlem sonucu": "Ergebnis der letzten Sammelverarbeitung",
  "oluşturuldu,": "erstellt,",
  "mevcut gönderi atlandı,": "vorhandene Sendungen übersprungen,",
  "hata.": "Fehler.",
  "Seçili ürünlerden en az birinde kredi yetersiz. Ürünleri değiştirin veya kredi tanımlayın.":
    "Für mindestens eines der ausgewählten Produkte reicht das Guthaben nicht aus. Ändern Sie die Produkte oder laden Sie Guthaben auf.",
  "Toplu kontrol için satır kalmadı.": "Für die Sammelprüfung sind keine Einträge mehr vorhanden.",
  "Takip:": "Tracking:",
  "Satırı çıkar": "Eintrag entfernen",
  "Etiket ürünü seçin": "Labelprodukt auswählen",
  "sipariş hazır. En fazla 100 sipariş tek toplu işlemde sıraya alınır.":
    "Bestellungen sind bereit. Pro Sammelvorgang werden höchstens 100 Bestellungen eingeplant.",
  "Toplu etiketleri oluştur": "Sammel-Labels erstellen",
  "Toplu etiket oluşturuluyor": "Sammel-Labels werden erstellt",
  "Ağırlık / Toplam": "Gewicht / Gesamt",
  "Koli sayısı": "Anzahl Pakete",
  "koli için": "für Pakete",
  "kredi gerekiyor; kullanılabilir kredi": "Guthaben erforderlich; verfügbares Guthaben",
  "Gönderiler ekranından tekrar indirebilirsiniz.": "Sie können die Datei im Bereich Sendungen erneut herunterladen.",
  "Sipariş otomatik arşivlendi.": "Die Bestellung wurde automatisch archiviert.",
  "Her koli için ayrı etiket ve ayrı takip numarası oluşturulur. Etiketler tek PDF dosyası halinde indirilir.":
    "Für jedes Paket werden ein eigenes Label und eine eigene Sendungsnummer erstellt. Die Labels werden als eine PDF-Datei heruntergeladen.",
  "PDF’yi yeniden oluştur": "PDF neu erstellen",
  "Yeni takip numarasıyla değiştir": "Durch neue Sendungsnummer ersetzen",
  "Etiket PDF’si yeniden oluşturulsun mu?": "Label-PDF neu erstellen?",
  "Bu işlem yeni etiket ürünü seçmez; aynı takip numarası ve mevcut etiket kaynağı kullanılır.":
    "Dabei wird kein neues Labelprodukt gewählt; Sendungsnummer und Labelquelle bleiben unverändert.",
  "Yeni takip numarası gerekiyorsa gönderi menüsündeki ‘Yeni takip numarasıyla değiştir’ işlemini kullanın.":
    "Wenn Sie eine neue Sendungsnummer benötigen, wählen Sie im Sendungsmenü „Durch neue Sendungsnummer ersetzen“.",
  "Yeni takip numaralı etiket oluşturulsun mu?": "Label mit neuer Sendungsnummer erstellen?",
  "DHL durumu işlem sırasında yeniden kontrol edilir; taşıyıcı hareketi bulunan etiket değiştirilemez.":
    "Der DHL-Status wird während des Vorgangs erneut geprüft; ein Label mit Transportbewegung kann nicht ersetzt werden.",
  "Eski etiket kredisi hesaba geri döner ve yeni etiket farklı bir kaynaktan oluşturulur.":
    "Das alte Label-Guthaben wird dem Konto gutgeschrieben und das neue Label aus einer anderen Quelle erstellt.",
  "Yeni takip numarası bağlı satış kanalına otomatik gönderilir.":
    "Die neue Sendungsnummer wird automatisch an den verbundenen Verkaufskanal übertragen.",
  "Yeni takip numarası oluştur": "Neue Sendungsnummer erstellen",
  "Farklı takip numaralı yeni etiket oluştur": "Neues Label mit anderer Sendungsnummer erstellen",
  "Aynı takip numaralı etiket PDF/ZIP dosyaları yeniden oluşturuldu.":
    "Die Label-PDF-/ZIP-Dateien wurden mit derselben Sendungsnummer neu erstellt.",
  "Yeni takip numaralı etiket oluşturulamadı.": "Das Label mit neuer Sendungsnummer konnte nicht erstellt werden.",
  "Ürün aralığı": "Produktbereich",
  "Seçili etiket ürünü için kullanılabilir kredi yok.": "Für das ausgewählte Labelprodukt ist kein Guthaben verfügbar.",
  "Alıcı, adres, posta kodu, şehir ve DE ülke kodu tamamlanmalı.":
    "Empfänger, Adresse, Postleitzahl, Ort und der Ländercode DE müssen vollständig sein.",
  "Siparişlerden oluşturulan toplu etiket arşivlerini tekrar indirebilirsiniz.":
    "Sie können aus Bestellungen erstellte Sammel-Label-Archive erneut herunterladen.",
  "Henüz toplu ZIP kaydı yok": "Noch kein Sammel-ZIP-Eintrag vorhanden",
  "Siparişleri seçip toplu etiket oluşturduğunuzda arşiv kayıtları burada görünür.":
    "Wenn Sie Bestellungen auswählen und Sammel-Labels erstellen, erscheinen die Archive hier.",
  "Birleşik PDF var": "Zusammengeführte PDF vorhanden",
  "Birleşik PDF yok": "Keine zusammengeführte PDF",
  "Sipariş toplu indirme": "Sammeldownload für Bestellungen",
  "Tekrar indir": "Erneut herunterladen",
  "İşlem devam ediyor": "Vorgang läuft",
  "Senkronizasyon sürüyor": "Synchronisierung läuft",
  "Senkronizasyon tamamlandı.": "Synchronisierung abgeschlossen.",
  "Senkron penceresini kapat": "Synchronisierungsfenster schließen",
  "Bu görünümde sadece arşive gönderilen siparişler gösterilir; geri alınan siparişler ana listeye döner.":
    "Diese Ansicht zeigt nur archivierte Bestellungen; wiederhergestellte Bestellungen kehren in die Hauptliste zurück.",
  "Billbee mağazası": "Billbee-Shop",
  "Aktif listeye dön": "Zur aktiven Liste zurückkehren",
  "Sayfadaki siparişleri seç": "Bestellungen auf dieser Seite auswählen",
  "Lieferadresse · Fatura farklı": "Lieferadresse · Rechnungsadresse abweichend",
  "· Fatura farklı": "· Rechnungsadresse abweichend",
  "· fatura adresi farklı": "· Rechnungsadresse abweichend",
  "Alıcı adı DHL'nin 35 karakter sınırını aşıyor. Etiket oluşturmadan önce kısaltın.":
    "Der Empfängername überschreitet das DHL-Limit von 35 Zeichen. Kürzen Sie ihn vor der Label-Erstellung.",
  "Alıcı adı, baştaki bölümü korunarak DHL'nin 35 karakter sınırına otomatik kısaltılacak.":
    "Der Empfängername wird automatisch auf das DHL-Limit von 35 Zeichen gekürzt; der Anfang bleibt erhalten.",
  "Şehir adı, baştaki bölümü korunarak posta koduyla birlikte DHL'nin 35 karakter sınırına otomatik kısaltılacak.":
    "Der Ortsname wird automatisch am Ende gekürzt, sodass Postleitzahl und Ort zusammen das DHL-Limit von 35 Zeichen einhalten.",
  "Sokak ve kapı numarası DHL'nin 35 karakter sınırını aşıyor. Etiket oluşturmadan önce kısaltın.":
    "Straße und Hausnummer überschreiten das DHL-Limit von 35 Zeichen. Kürzen Sie die Angabe vor der Label-Erstellung.",
  "Adres eki DHL'nin 35 karakter sınırını aşıyor. Etiket oluşturmadan önce kısaltın.":
    "Der Adresszusatz überschreitet das DHL-Limit von 35 Zeichen. Kürzen Sie ihn vor der Label-Erstellung.",
  "Kayıt yok": "Keine Datensätze",
  "Sayfa başı": "Pro Seite",
  "Sayfa başı order sayısı": "Bestellungen pro Seite",
  "Sipariş sayfaları": "Bestellseiten",
  "Sonraki": "Weiter",
  "Toplu etiket kontrolünü kapat": "Prüfung der Sammel-Labels schließen",
  "Düzenlenmesi gereken satır var": "Einträge müssen korrigiert werden",
  "Satırlar hazır": "Einträge sind bereit",
  "Zaten vardı": "Bereits vorhanden",
  "Hata": "Fehler",
  "Etiketler oluşturuldu, liste ve ZIP geçmişi yenileniyor.":
    "Die Labels wurden erstellt; Liste und ZIP-Verlauf werden aktualisiert.",
  "Etiket oluşturma penceresini kapat": "Fenster zur Label-Erstellung schließen",
  "Toplu ZIP geçmişini kapat": "ZIP-Sammelverlauf schließen",
  "Toplu ZIP geçmişi yükleniyor": "ZIP-Sammelverlauf wird geladen",
  "Geçmişteki toplu ZIP yeniden indiriliyor.": "Die frühere Sammel-ZIP-Datei wird erneut heruntergeladen.",
  "Sipariş detayı alınamadı.": "Die Bestelldetails konnten nicht geladen werden.",
  "Satılan ürünler": "Verkaufte Artikel",
  "Bu sipariş için ürün bilgisi bulunamadı.": "Für diese Bestellung sind keine Artikelinformationen vorhanden.",
  "Adres eki": "Adresszusatz",
  "Posta kodu ve şehir": "Postleitzahl und Ort",
  "Alıcı adresi DHL'nin 5 satır sınırını aşıyor. Adres ekini veya alıcı satırlarını kısaltın.":
    "Die Empfängeradresse überschreitet das DHL-Limit von 5 Zeilen. Kürzen Sie den Adresszusatz oder die Empfängerzeilen.",
  "Adres DHL etiket formatına uygun değil.": "Die Adresse entspricht nicht dem DHL-Label-Format.",
  "Etiket ürünü seçilmeli.": "Ein Labelprodukt muss ausgewählt werden.",
  "Alıcı adı eksik.": "Der Empfängername fehlt.",
  "Adres 1 eksik.": "Die erste Adresszeile fehlt.",
  "Şehir eksik.": "Der Ort fehlt.",
  "Şimdilik sadece DE gönderileri destekleniyor.": "Derzeit werden nur Sendungen innerhalb Deutschlands unterstützt.",
  "Sipariş etiketi": "Bestelllabel",
  "Özel DHL adresi; gerekirse adresi normal teslimat adresiyle değiştirerek deneyin.":
    "Besondere DHL-Adresse; verwenden Sie bei Bedarf stattdessen eine normale Lieferadresse.",

  // Team, profile, support and training
  "Ekip": "Team",
  "Ekip üyeleri alınamadı.": "Die Teammitglieder konnten nicht geladen werden.",
  "Ekip üyesi oluşturuldu.": "Das Teammitglied wurde erstellt.",
  "Ekip üyesi oluşturulamadı.": "Das Teammitglied konnte nicht erstellt werden.",
  "Ekip üyesi güncellendi.": "Das Teammitglied wurde aktualisiert.",
  "Ekip üyesi güncellenemedi.": "Das Teammitglied konnte nicht aktualisiert werden.",
  "Yeni ekip üyesi şifresi en az 6 karakter olmalı.": "Das Passwort des neuen Teammitglieds muss mindestens 6 Zeichen lang sein.",
  "Şifre güncellendi.": "Das Passwort wurde aktualisiert.",
  "Şifre güncellenemedi.": "Das Passwort konnte nicht aktualisiert werden.",
  "Henüz girilmedi": "Noch nicht angegeben",
  "Profil bilgileri alınamadı.": "Die Profildaten konnten nicht geladen werden.",
  "Profil güncellendi.": "Das Profil wurde aktualisiert.",
  "Profil güncellenemedi.": "Das Profil konnte nicht aktualisiert werden.",
  "Yeni şifreler eşleşmiyor.": "Die neuen Passwörter stimmen nicht überein.",
  "Fatura": "Rechnung",
  "Giriş doğrulama tercihleri.": "Einstellungen für die Anmeldebestätigung.",
  "Girişte e-posta doğrulama kodu istenir.": "Bei der Anmeldung wird ein Bestätigungscode per E-Mail angefordert.",
  "Panelde görünen iletişim ve firma bilgileri.": "Im Kundenbereich angezeigte Kontakt- und Firmendaten.",
  "Fatura adresi ve ülke bilgisi.": "Rechnungsadresse und Land.",
  "Gönderici": "Absender",
  "Gönderici bilgileri": "Absenderdaten",
  "Etiketlerde kullanılacak gönderici adresi.": "Absenderadresse, die auf den Labels verwendet wird.",
  "Şifre güncelle": "Passwort aktualisieren",
  "Mevcut şifrenizi doğrulayarak yeni şifre belirleyin.": "Bestätigen Sie Ihr aktuelles Passwort und legen Sie ein neues fest.",
  "Destek talebi gönderilemedi.": "Die Supportanfrage konnte nicht gesendet werden.",
  "Destek raporu alınamadı.": "Der Supportbericht konnte nicht geladen werden.",
  "Eğitim videoları alınamadı.": "Die Schulungsvideos konnten nicht geladen werden.",
  "Kategori": "Kategorie",
  "Acil": "Dringend",
  "Konu": "Betreff",
  "Mesaj": "Nachricht",
  "KenPost ana sayfa": "KenPost-Startseite",
  "Türkçe": "Türkisch",
  "English": "Englisch",
  "Rapor listesi": "Berichtsliste",
  "Takip, sipariş, alıcı, şehir veya ürün ara": "Nach Trackingnummer, Bestellung, Empfänger, Stadt oder Produkt suchen",
  "E-posta": "E-Mail",
  "Ad": "Vorname",
  "Soyad": "Nachname",
  "Hareket / durum": "Bewegung / Status",
  "Rapor önizleme": "Berichtsvorschau",
  "Ay": "Monat",
  "İade": "Retoure",
  "3 ay": "3 Monate",
  "Taslak": "Entwurf",
  "Final": "Abgeschlossen",
  "Normal purchase": "Normaler Kauf",
  "100 takibi senkronla": "100 Trackingnummern synchronisieren",
  "Sadece iptaller": "Nur Stornierungen",
  "Tüm takip senkronları": "Alle Tracking-Synchronisierungen",
  "Etiket / indirme": "Label / Download",
  "Mağaza bağlantısı": "Shop-Verbindung",
  "Ekle": "Hinzufügen",
  "Önceki": "Zurück",
  "Gönder": "Absenden",
  "Devre dışı": "Deaktiviert",

  // Shipments, invoices and balances
  "Gönderilerim": "Meine Sendungen",
  "Etiketli gönderileri eski operasyon akışındaki gibi filtreleyin, indirin, yenileyin ve takip senkronlarını yönetin.":
    "Filtern, laden und aktualisieren Sie Sendungen mit Label und verwalten Sie deren Tracking-Synchronisierung.",
  "Gönderi detayı alınamadı.": "Die Sendungsdetails konnten nicht geladen werden.",
  "Tracking sync başlatılamadı.": "Die Tracking-Synchronisierung konnte nicht gestartet werden.",
  "DHL takip aç": "DHL-Sendungsverfolgung öffnen",
  "Takip linki yok": "Kein Trackinglink",
  "Son kontrol:": "Letzte Prüfung:",
  "· Son event:": "· Letztes Ereignis:",
  "Kaydedilmiş carrier event yok.": "Kein gespeichertes Carrier-Ereignis vorhanden.",
  "Etiket indirmeleri": "Label-Downloads",
  "PDF ve ZIP dosyaları tarayıcıda açılmadan indirilecek şekilde hazırlanır.":
    "PDF- und ZIP-Dateien werden für den direkten Download vorbereitet, ohne sie im Browser zu öffnen.",
  "Adobe PDF indir": "Adobe-PDF herunterladen",
  "Aç": "Öffnen",
  "Seçili ZIP indir": "Auswahl als ZIP herunterladen",
  "Seçili tek PDF indir": "Auswahl als eine PDF herunterladen",
  "Tüm filtrelenen gönderileri seç": "Alle gefilterten Sendungen auswählen",
  "Tümü seçiliyor": "Alle werden ausgewählt",
  "Etiket dosyası henüz hazır değil.": "Die Label-Datei ist noch nicht bereit.",
  "Filtrelenen sonuçlarda indirilebilir aktif gönderi bulunamadı.": "Unter den gefilterten Ergebnissen wurde keine aktive Sendung mit herunterladbarem Label gefunden.",
  "Filtrelenen gönderilerin tamamı seçilemedi.": "Die gefilterten Sendungen konnten nicht vollständig ausgewählt werden.",
  "Seçili etiketler tek PDF dosyasında birleştiriliyor.": "Die ausgewählten Labels werden in einer PDF-Datei zusammengeführt.",
  "Seçili etiketler tek PDF olarak hazırlanamadı.": "Die ausgewählten Labels konnten nicht als eine PDF-Datei vorbereitet werden.",
  "OLUŞTURULAN": "ERSTELLT",
  "Oluşturulan": "Erstellt",
  "Sorunlu": "Problematisch",
  "KULLANILAN ÜRÜN": "VERWENDETES PRODUKT",
  "Kullanılan ürün": "Verwendetes Produkt",
  "Tüm türler": "Alle Typen",
  "Tüm platformlar": "Alle Plattformen",
  "Tüm carrier durumları": "Alle Carrier-Status",
  "İade sürecinde": "In Retourenbearbeitung",
  "DHL durumu alınamadı": "DHL-Status nicht verfügbar",
  "Sıralama: en yeni": "Sortierung: neueste zuerst",
  "Sıralama: etiket ürünü": "Sortierung: Labelprodukt",
  "Tüm taşıyıcılar": "Alle Versanddienstleister",
  "Tüm etiket ürünleri": "Alle Labelprodukte",
  "Sayfadaki gönderileri seç": "Sendungen auf dieser Seite auswählen",
  "Seçimi temizle": "Auswahl aufheben",
  "Filtreleri sıfırla": "Filter zurücksetzen",
  "Faturalar alınamadı.": "Die Rechnungen konnten nicht geladen werden.",
  "Manuel oluşturulan faturalarınız ve Shopify satın alma kayıtlarınız.":
    "Ihre manuell erstellten Rechnungen und Shopify-Kaufdatensätze.",
  "Fatura CSV": "Rechnungs-CSV",
  "Alım CSV": "Kauf-CSV",
  "Fatura numarası, sipariş, mağaza veya etiket satın alma kaydı arayın.":
    "Nach Rechnungsnummer, Bestellung, Shop oder Labelkauf suchen.",
  "Fatura no, sipariş, mağaza veya ürün ara": "Rechnungs-Nr., Bestellung, Shop oder Produkt suchen",
  "Tüm fatura durumları": "Alle Rechnungsstatus",
  "Tüm Shopify alımları": "Alle Shopify-Käufe",
  "Shopify alım": "Shopify-Kauf",
  "Alım toplamı": "Kaufsumme",
  "Faturalar yükleniyor": "Rechnungen werden geladen",
  "FATURA": "RECHNUNG",
  "ALIM TOPLAMI": "KAUFSUMME",
  "FATURA NO": "RECHNUNGS-NR.",
  "FATURA ADET": "RECHNUNGEN",
  "NET TUTAR": "NETTOBETRAG",
  "Fatura no": "Rechnungsnummer",
  "Fatura adet": "Rechnungsanzahl",
  "Fatura detayı alınamadı.": "Die Rechnungsdetails konnten nicht geladen werden.",
  "Fatura detayı": "Rechnungsdetails",
  "Fatura güncellenemedi.": "Die Rechnung konnte nicht aktualisiert werden.",
  "Manuel yükleme": "Manuelle Aufladung",
  "Düşüm": "Abzug",
  "Tamamlandı": "Abgeschlossen",
  "Etiket bakiyeleri alınamadı.": "Die Label-Guthaben konnten nicht geladen werden.",
  "Etiket bakiyeleri yükleniyor": "Label-Guthaben werden geladen",
  "Bakiye artışı": "Guthabenerhöhung",
  "Bakiye düşümü": "Guthabenabzug",
  "Kullanılabilir": "Verfügbar",
  "Müsait": "Verfügbar",
  "Ürün bazlı bakiye": "Guthaben nach Produkt",
  "Satın alınan, yüklenen ve kalan etiket kredilerini ürün ve hareket bazında yönetin.":
    "Verwalten Sie gekaufte, aufgeladene und verbleibende Label-Guthaben nach Produkt und Buchung.",
  "Henüz etiket bakiyesi yok.": "Noch kein Label-Guthaben vorhanden.",
  "Alınan": "Erhalten",
  "Son alım": "Letzter Kauf",
  "Tüm hareketler": "Alle Buchungen",
  "Satın alma/yükleme": "Kauf/Aufladung",
  "Düşük": "Niedrig",
  "Son satın alma ve manuel bakiye işlemleri.": "Letzte Käufe und manuelle Guthabenbuchungen.",
  "Ürün, not veya durum ara": "Nach Produkt, Notiz oder Status suchen",
  "Süresi doldu": "Abgelaufen",

  // Label inventory
  "Atanmış etiketleri takip edin, tekil PDF indirin ve seçili ya da filtreli kayıtları ZIP/CSV olarak dışa aktarın.":
    "Verfolgen Sie zugewiesene Labels, laden Sie einzelne PDFs herunter und exportieren Sie ausgewählte oder gefilterte Datensätze als ZIP/CSV.",
  "Seçili ZIP": "Auswahl als ZIP",
  "İndirme geçmişi": "Download-Verlauf",
  "Filtre ZIP": "Gefilterte ZIP-Datei",
  "dosyasına yazıldı": "in Datei geschrieben",
  "Dosyayı indir": "Datei herunterladen",
  "Admin etiket işlemi": "Admin-Labelaktion",
  "Müşteriye atanmış fakat henüz kullanılmamış etiketleri güvenli biçimde iade edin veya temiz etiketlerle değiştirin.":
    "Geben Sie dem Kunden zugewiesene, noch unbenutzte Labels sicher zurück oder ersetzen Sie sie durch unbenutzte Labels.",
  "Yeni etiketle değiştir": "Durch neues Label ersetzen",
  "SEÇILI ETIKET": "AUSGEWÄHLTE LABELS",
  "Havuza iade": "In den Bestand zurückgeben",
  "Seçili etiket": "Ausgewähltes Label",
  "Daha önce indirilen": "Bereits heruntergeladen",
  "Bu seçim yalnızca değiştirilebilir.": "Diese Auswahl kann nur ersetzt werden.",
  "Takip numarası, ürün, durum ve dış sistem kullanımına göre listeyi daraltın.":
    "Filtern Sie die Liste nach Trackingnummer, Produkt, Status und Nutzung in externen Systemen.",
  "Tüm dışa aktarımlar": "Alle Exportstatus",
  "Export edilmemiş": "Nicht exportiert",
  "Export edilmiş": "Exportiert",
  "Dış sistemde kullanılmamış": "Nicht in externem System verwendet",
  "Dış sistemde kullanılmış": "In externem System verwendet",
  "Dış sistemde kullanıldı": "In externem System verwendet",
  "Tüm ürünler": "Alle Produkte",
  "50/sayfa": "50/Seite",
  "100/sayfa": "100/Seite",
  "250/sayfa": "250/Seite",
  "DIŞ SISTEM": "EXTERNES SYSTEM",
  "İNDIR": "DOWNLOAD",
  "Etiket envanteri alınamadı.": "Der Label-Bestand konnte nicht geladen werden.",
  "Export geçmişi alınamadı.": "Der Exportverlauf konnte nicht geladen werden.",
  "Export için en az bir müsait etiket seçin.": "Wählen Sie mindestens ein verfügbares Label für den Export aus.",
  "Bu seçim veya filtre için export edilecek etiket yok.": "Für diese Auswahl oder diesen Filter sind keine Labels zum Export vorhanden.",
  "Devam ederseniz bu etiketler tekrar export dosyasına alınır ve export geçmişi güncellenir.":
    "Wenn Sie fortfahren, werden diese Labels erneut exportiert und der Exportverlauf wird aktualisiert.",
  "Envanter export oluşturulamadı.": "Der Bestandsexport konnte nicht erstellt werden.",
  "İşlem için en az bir atanmış ve kullanılmamış etiket seçin.":
    "Wählen Sie für diese Aktion mindestens ein zugewiesenes, unbenutztes Label aus.",
  "Daha önce indirilen etiketler doğrudan havuza iade edilemez. Bu etiketleri yeni etiketlerle değiştirin.":
    "Bereits heruntergeladene Labels können nicht direkt in den Bestand zurückgegeben werden. Ersetzen Sie diese Labels durch neue.",
  "Seçili etiketler değiştirilsin mi?": "Ausgewählte Labels ersetzen?",
  "Seçili etiketler havuza iade edilsin mi?": "Ausgewählte Labels in den Bestand zurückgeben?",
  "Eski etiketler hatalı stok olarak ayrılacak.": "Die bisherigen Labels werden als fehlerhafter Bestand ausgesondert.",
  "Müşterinin toplam kullanılabilir etiketi ve satın alma geçmişi değişmeyecek.":
    "Die Gesamtzahl verfügbarer Labels und der Kaufverlauf des Kunden bleiben unverändert.",
  "Bu admin onayı, müşteriye son 3 ay içinde verilen fakat hiç indirilmemiş ve kullanılmamış etiketlerde bekleme kuralını aşar.":
    "Diese Admin-Freigabe übergeht die Wartefrist für Labels, die dem Kunden in den letzten 3 Monaten zugewiesen, aber nie heruntergeladen oder verwendet wurden.",
  "İndirilmiş, dış sistemde kullanılmış veya gerçek DHL hareketi bulunan etiketler yine kesinlikle engellenir.":
    "Heruntergeladene, in externen Systemen verwendete oder bereits von DHL bewegte Labels bleiben weiterhin strikt gesperrt.",
  "Müşterinin kullanılabilir etiketi seçilen adet kadar azalacak.":
    "Die verfügbaren Labels des Kunden werden um die ausgewählte Anzahl reduziert.",
  "Etiketleri değiştir": "Labels ersetzen",
  "Onayla ve havuza iade et": "Bestätigen und in den Bestand zurückgeben",
  "Admin destek modunda açık onay vererek son 3 aylık müşteri koruma süresini aştı.":
    "Im Admin-Supportmodus wurde die dreimonatige Kundenschutzfrist ausdrücklich übergangen.",
  "Etiket işlemi tamamlanamadı.": "Die Labelaktion konnte nicht abgeschlossen werden.",
  "Takip no, dosya adı veya ürün ara": "Nach Trackingnummer, Dateiname oder Produkt suchen",
  "Download geçmişi": "Download-Verlauf",
  "Önceden oluşturulan CSV/ZIP export dosyaları.": "Zuvor erstellte CSV-/ZIP-Exportdateien.",
  "Henüz export geçmişi yok.": "Noch kein Exportverlauf vorhanden.",
  "Etiket envanteri yükleniyor": "Label-Bestand wird geladen",
  "Sayfadaki müsait etiketleri seç": "Verfügbare Labels auf dieser Seite auswählen",
  "İndir": "Herunterladen",
  "Bu filtreye uygun etiket yok.": "Keine Labels entsprechen diesem Filter.",
  "Dış sistem": "Externes System",
  "kayıttan": "von Datensätzen",
  "gösteriliyor.": "werden angezeigt.",

  // Reports and affiliate
  "Aylık kullanım raporu": "Monatlicher Nutzungsbericht",
  "Ay bazında kullanılan etiket, gönderi ve açık sipariş görünümü.":
    "Monatliche Übersicht über verwendete Labels, Sendungen und offene Bestellungen.",
  "Kargo sağlığı": "Versandstatus",
  "Teslim, yolda, geciken, sorunlu ve müdahale gereken gönderiler.":
    "Zugestellte, unterwegs befindliche, verspätete und problematische Sendungen sowie Sendungen mit Handlungsbedarf.",
  "Aylık kullanım": "Monatliche Nutzung",
  "Kullanılan etiket, teslim, yolda, iade ve sorun görünümü.":
    "Übersicht über verwendete Labels, Zustellungen, laufende Sendungen, Retouren und Probleme.",
  "Teslimat performansı": "Zustellleistung",
  "Carrier ve platform bazında paket performansı.": "Paketleistung nach Versanddienstleister und Plattform.",
  "Teslim, yolda, iade ve sorun sinyalleri.":
    "Signale für Zustellung, Transport, Retoure und Probleme.",
  "Ürün/kg bazında mevcut bakiye ve tahmini bitiş.": "Aktuelles Guthaben und prognostizierte Reichweite nach Produkt/Gewicht.",
  "Sorunlu gönderiler": "Problematische Sendungen",
  "İade, carrier hatası ve takip senkronu sorunları.": "Retouren, Carrier-Fehler und Probleme bei der Tracking-Synchronisierung.",
  "Etiket bekleyen siparişler": "Bestellungen ohne Label",
  "Açık kalan ve etiketi oluşturulmamış siparişler.": "Offene Bestellungen, für die noch kein Label erstellt wurde.",
  "Satın alma raporu": "Kaufbericht",
  "Etiket alımları, tutar ve ürün kırılımı.": "Labelkäufe nach Betrag und Produkt.",
  "BAŞLANGIÇ TARIHI": "STARTDATUM",
  "BITIŞ TARIHI": "ENDDATUM",
  "Başlangıç tarihi": "Startdatum",
  "Bitiş tarihi": "Enddatum",
  "ÜRÜN / KG": "PRODUKT / KG",
  "Ürün / kg": "Produkt / kg",
  "KULLANILAN ETIKET": "VERWENDETE LABELS",
  "Kullanılan etiket": "Verwendete Labels",
  "TESLIM EDILEN": "ZUGESTELLT",
  "SORUNLU": "PROBLEMATISCH",
  "Affiliate bilgileri alınamadı.": "Die Partnerprogrammdaten konnten nicht geladen werden.",
  "Affiliate programı açıldı.": "Das Partnerprogramm wurde aktiviert.",
  "Affiliate profili oluşturulamadı.": "Das Partnerprofil konnte nicht erstellt werden.",
  "Referans linki kopyalandı.": "Der Empfehlungslink wurde kopiert.",
  "Referans ve kazanç": "Empfehlungen & Guthaben",
  "Referans kontrolü": "Empfehlungsübersicht",
  "Müşteri, kod veya komisyon hareketi arayın.": "Nach Kunde, Code oder Provisionsbuchung suchen.",
  "Müşteri, e-posta, kod veya hareket ara": "Nach Kunde, E-Mail, Code oder Buchung suchen",
  "Hesabınıza bağlı müşteri, kod veya komisyon hareketlerini filtreleyin.": "Filtern Sie Kunden, Codes und Provisionsbewegungen, die bereits mit Ihrem Konto verknüpft sind.",
  "Bağlı referanslarda müşteri, e-posta veya kod ara": "Verknüpfte Empfehlungen nach Kunde, E-Mail oder Code durchsuchen",
  "Bu alan yalnızca hesabınıza zaten bağlı referansları filtreler; yeni bir müşteri bağlantısı oluşturmaz. Yeni kayıtlar referans linkinizle otomatik bağlanır. Mevcut bir müşteri hesabının sonradan bağlanması için destek ekibi yönetici panelindeki Affiliate hesapları ekranını kullanır.": "Dieses Feld filtert nur bereits mit Ihrem Konto verknüpfte Empfehlungen; es erstellt keine neue Kundenverknüpfung. Neuanmeldungen werden über Ihren Empfehlungslink automatisch zugeordnet. Für die nachträgliche Zuordnung eines bestehenden Kundenkontos nutzt der Support die Seite Affiliate-Konten im Adminbereich.",
  "Tüm komisyon durumları": "Alle Provisionsstatus",
  "Bekleyen": "Ausstehend",
  "Bekleyen (24 saat)": "Ausstehend (24 Stunden)",
  "Onaylanan": "Genehmigt",
  "Ödenen": "Ausgezahlt",
  "Geçersiz": "Ungültig",
  "Komisyonun kullanımı": "Verwendung der Provision",
  "Etiket ürünü ve pozitif tam adet seçin.": "Wählen Sie ein Label-Produkt und geben Sie eine positive ganze Stückzahl ein.",
  "Kazanç etikete dönüştürülemedi.": "Das Guthaben konnte nicht in Label-Guthaben umgewandelt werden.",
  "Etikete çevrilen": "In Labels umgewandelt",
  "Nakit ödenen": "Bar ausgezahlt",
  "Kazancınızı etiket bakiyesine çevirin": "Guthaben in Label-Guthaben umwandeln",
  "Onaylanan referans veya bonus kazancınızla gerçek etiket kredisi alın.": "Nutzen Sie genehmigte Empfehlungs- oder Bonusguthaben für echtes Label-Guthaben.",
  "Referans veya bonus kazancınızı yönetici onayı beklemeden, mevcut tutarınızı aşmayacak şekilde etiket kredisine çevirin.": "Wandeln Sie Empfehlungs- oder Bonusguthaben sofort und ohne Admin-Freigabe in Label-Guthaben um, ohne Ihr verfügbares Guthaben zu überschreiten.",
  "Kazançlar 24 saat sonra otomatik onaylanır; müşteri isterse bekleme sırasında da yönetici onayı olmadan etiket kredisine çevirebilir.": "Guthaben wird nach 24 Stunden automatisch freigegeben; während der Wartezeit kann der Kunde es auch ohne Administratorfreigabe in Label-Guthaben umwandeln.",
  "Kullanılabilir toplam": "Insgesamt verfügbar",
  "Doğrudan dönüşüm": "Sofortige Umwandlung",
  "Onaylanan ve bekleyen kazançlarınız birlikte kullanılabilir. Seçtiğiniz etiketlerin toplamı mevcut kazancınızı aşamaz; kullanılan bekleyen hareketler işlem sırasında otomatik onaylanır.": "Genehmigte und ausstehende Guthaben können gemeinsam verwendet werden. Die ausgewählten Labels dürfen Ihr verfügbares Guthaben nicht überschreiten; verwendete ausstehende Buchungen werden dabei automatisch genehmigt.",
  "Etiket kullanımından oluşan kazanç 24 saatlik kontrol süresinin sonunda otomatik onaylanır. Onay beklerken de etiket bakiyesine çevrilebilir; yönetici işlemi gerekmez.": "Guthaben aus der Label-Nutzung wird nach der 24-stündigen Prüfzeit automatisch freigegeben. Es kann auch während der Wartezeit in Label-Guthaben umgewandelt werden; ein Administratoreingriff ist nicht erforderlich.",
  "Bu ay satın alma": "Diesen Monat gekauft",
  "Bu ay kullanılan": "Diesen Monat verwendet",
  "Kullanılan (tüm zamanlar)": "Verwendet (gesamt)",
  "Komisyona giren": "Provisionsberechtigt",
  "Dönem içindeki uygun hareketler": "Geeignete Buchungen im Zeitraum",
  "Maksimum": "Maximum",
  "Toplam çevrilen": "Insgesamt umgewandelt",
  "/ adet · stok": "/ Stück · Bestand",
  "Kullanılacak kazanç": "Zu verwendendes Guthaben",
  "KDV dahil etiket fiyatı üzerinden hesaplanır. Kalan kazanç hesabınızda kalır.": "Die Berechnung erfolgt zum Label-Preis einschließlich Mehrwertsteuer. Das restliche Guthaben bleibt auf Ihrem Konto.",
  "Bekleyen kazanç neden kullanılamıyor?": "Warum kann ausstehendes Guthaben nicht verwendet werden?",
  "Bekleyen tutar yönetici kontrolündedir. Onaylandığında otomatik olarak kullanılabilir alana geçer. Yönetici isterse bekleyen tutarı doğrudan etiket bakiyenize de aktarabilir.": "Ausstehendes Guthaben wird von einem Administrator geprüft. Nach der Genehmigung wird es automatisch verfügbar. Ein Administrator kann ausstehendes Guthaben auch direkt in Ihr Label-Guthaben übertragen.",
  "Etikete dönüşüm geçmişi": "Verlauf der Label-Umwandlungen",
  "Kazançtan etiket bakiyesine yapılan son işlemler.": "Letzte Umwandlungen von Guthaben in Label-Guthaben.",
  "Henüz etikete dönüştürülen kazanç yok.": "Es wurde noch kein Guthaben in Label-Guthaben umgewandelt.",
  "Kullanılan kazanç": "Verwendetes Guthaben",
  "Komisyon tutarları etiket satın alma sepetinden ayrı yönetilir.": "Provisionsbeträge werden getrennt vom Warenkorb für Labelkäufe verwaltet.",
  "Kullanımdan oluşmuştur ve yönetici kontrolü bekler. Bu tutar checkout sırasında otomatik indirim veya etiket kredisi olarak kullanılamaz.": "Dieser Betrag ist durch Nutzung entstanden und wartet auf die Prüfung durch einen Administrator. Er kann beim Checkout nicht automatisch als Rabatt oder Label-Guthaben verwendet werden.",
  "Kontrolü tamamlanmış, ödeme işlemine hazır komisyon tutarıdır.": "Diese Provision wurde geprüft und ist zur Auszahlung bereit.",
  "Yönetici tarafından ödemesi tamamlanıp referansıyla kapatılmış komisyon tutarıdır.": "Diese Provision wurde von einem Administrator ausgezahlt und mit einer Zahlungsreferenz abgeschlossen.",
  "Henüz bağlı referans yok. Yeni kayıtlar referans linkiyle otomatik bağlanır; mevcut hesap bağlantısını destek ekibi yapar.": "Es gibt noch keine verknüpften Empfehlungen. Neuanmeldungen werden über den Empfehlungslink automatisch zugeordnet; bestehende Konten verknüpft der Support.",
  "Tamamlanan siparişleri gizle": "Abgeschlossene Bestellungen ausblenden",
  "Siparişlerde gösterilecek ülkeler": "In Bestellungen angezeigte Länder",
  "Boş: tüm ülkeler · Örnek: DE, AT": "Leer: alle Länder · Beispiel: DE, AT",
  "İki harfli ülke kodlarını virgülle ayırın. Boş bırakırsanız tüm ülkeler görünür.": "Trennen Sie zweistellige Ländercodes durch Kommas. Leer lassen, um alle Länder anzuzeigen.",
  "Sipariş ağırlığına göre otomatik": "Automatisch nach Bestellgewicht",
  "Kaynak siparişte ağırlık bilgisi eksik. Yanlış DHL ürünü seçilmemesi için sistem otomatik seçim yapmadı; ürünü manuel doğrulayın.": "In der Quellbestellung fehlt die Gewichtsangabe. Um die Auswahl eines falschen DHL-Produkts zu vermeiden, hat das System keine automatische Auswahl getroffen; prüfen Sie das Produkt manuell.",
  "KenPost ödeme hazırlanıyor": "KenPost-Zahlung wird vorbereitet",
  "Ödeme sayfanız hazırlanıyor…": "Ihre Zahlungsseite wird vorbereitet…",
  "etiket ·": "Label ·",

  // Manual labels and purchases
  "XLSX dosyası okunamadı.": "Die XLSX-Datei konnte nicht gelesen werden.",
  "XLSX central directory okunamadı.": "Das zentrale XLSX-Verzeichnis konnte nicht gelesen werden.",
  "XLSX içinde çalışma sayfası bulunamadı.": "In der XLSX-Datei wurde kein Arbeitsblatt gefunden.",
  "Etiket bilgileri alınamadı.": "Die Labeldaten konnten nicht geladen werden.",
  "Adres önerisi uygulandı.": "Der Adressvorschlag wurde übernommen.",
  "Adres bilgileri otomatik ayrıştırıldı.": "Die Adressdaten wurden automatisch aufgeteilt.",
  "Alıcı adresini tek kutuya yapıştırın; alanlar otomatik doldurulur.":
    "Fügen Sie die Empfängeradresse in ein Feld ein; die Felder werden automatisch ausgefüllt.",
  "Eski manuel alıcı forma aktarıldı.": "Der letzte manuelle Empfänger wurde in das Formular übernommen.",
  "Varsayılan etiket seçimi kaydedildi.": "Die Standardauswahl für Labels wurde gespeichert.",
  "Varsayılan seçim kaydedilemedi.": "Die Standardauswahl konnte nicht gespeichert werden.",
  "Import dosyası okunamadı.": "Die Importdatei konnte nicht gelesen werden.",
  "Import için geçerli satır bulunamadı.": "Für den Import wurden keine gültigen Zeilen gefunden.",
  "Toplu manuel etiket oluşturulamadı.": "Die manuellen Sammel-Labels konnten nicht erstellt werden.",
  "Etiket yeniden oluşturulamadı.": "Das Label konnte nicht erneut erstellt werden.",
  "Manuel etiket yeniden oluşturuldu.": "Das manuelle Label wurde erneut erstellt.",
  "Manuel gönderi iptal edilsin mi?": "Manuelle Sendung stornieren?",
  "Etiket kredisi müşteri bakiyesine geri alınır ve gönderi iptal listesinde görünür.":
    "Das Label-Guthaben wird dem Kundenkonto gutgeschrieben und die Sendung erscheint in der Stornoliste.",
  "Gönderi iptal edildi ve etiket kredisi hesabınıza geri döndü.":
    "Die Sendung wurde storniert und das Label-Guthaben Ihrem Konto gutgeschrieben.",
  "Bazı etiketler oluşturulamadı.": "Einige Labels konnten nicht erstellt werden.",
  "Etiket ürünü zorunlu": "Labelprodukt erforderlich",
  "etiket hazır": "Labels bereit",
  "etiket için yeterli kredi yok. Kullanılabilir kredi:": "Labels: nicht genügend Guthaben. Verfügbares Guthaben:",
  "PDF, ZIP veya gönderi detayına buradan hızlıca ulaşabilirsiniz.":
    "Hier erreichen Sie schnell PDF, ZIP-Datei oder Sendungsdetails.",
  "Seçili ürün": "Ausgewähltes Produkt",
  "Adres kontrolü": "Adressprüfung",
  "Tekrar kullanım": "Wiederverwendung",
  "eski manuel alıcı": "letzte manuelle Empfänger",
  "Aşağıdaki listeden seçip tekrar yazmadan forma aktarabilirsiniz.":
    "Wählen Sie einen Eintrag aus der Liste aus und übernehmen Sie ihn ohne erneute Eingabe in das Formular.",
  "Packstation veya Postfiliale adresleri manuel etiket için bloklanır. Bu adresler mağaza siparişi üzerinden veya doğru alıcı adresiyle işlenmeli.":
    "Packstation- und Postfiliale-Adressen sind für manuelle Labels gesperrt. Verarbeiten Sie diese Adressen über eine Shopbestellung oder mit einer korrekten Empfängeradresse.",
  "Seçili üründe kullanılabilir kredi yok. Etiket oluşturmak için farklı ürün seçin veya kredi satın alın.":
    "Für das ausgewählte Produkt ist kein Guthaben verfügbar. Wählen Sie ein anderes Produkt oder kaufen Sie Guthaben.",
  "Son manuel alıcılar": "Letzte manuelle Empfänger",
  "Eski müşteriyi seçip adresi tekrar yazmadan yeni etiket oluşturabilirsiniz.":
    "Wählen Sie einen früheren Empfänger aus und erstellen Sie ein neues Label, ohne die Adresse erneut einzugeben.",
  "Henüz manuel oluşturulmuş alıcı bulunmuyor. İlk manuel etiketten sonra burada tekrar kullanım listesi oluşacak.":
    "Noch kein manuell erstellter Empfänger vorhanden. Nach dem ersten manuellen Label erscheint hier die Wiederverwendungsliste.",
  "Sipariş adresi kullanılacak": "Bestelladresse wird verwendet",
  "Adres tipi desteklenmiyor": "Adresstyp wird nicht unterstützt",
  "Manuel adres hazır": "Manuelle Adresse ist bereit",
  "Mağazadan gelen müşteri adresiyle etiket üretir.": "Erstellt das Label mit der vom Shop übermittelten Kundenadresse.",
  "Alıcı, adres, posta kodu ve şehir dolu olmalı.": "Empfänger, Adresse, Postleitzahl und Ort müssen ausgefüllt sein.",
  "Etiket ürünleri alınamadı.": "Die Labelprodukte konnten nicht geladen werden.",
  "Ödeme için sepete en az bir etiket ürünü ekleyin.": "Legen Sie für die Zahlung mindestens ein Labelprodukt in den Warenkorb.",
  "Ödeme bağlantısı şu anda kullanılamıyor. Lütfen destek ekibine bildirin.":
    "Die Zahlungsverbindung ist derzeit nicht verfügbar. Bitte informieren Sie den Support.",
  "Ödeme için önce ürün miktarı girin veya Sepete ekle düğmesini kullanın.":
    "Geben Sie zuerst eine Produktmenge ein oder verwenden Sie die Schaltfläche In den Warenkorb.",
  "Sepetteki miktarı mevcut stok sınırına düşürün.":
    "Reduzieren Sie die Menge im Warenkorb auf den verfügbaren Lagerbestand.",
  "Sepet checkout olarak açıldı. Ödeme tamamlanınca bakiye otomatik güncellenecek.":
    "Der Warenkorb wurde zur Kasse geöffnet. Nach Abschluss der Zahlung wird das Guthaben automatisch aktualisiert.",
  "Ödeme sayfası açıldı. Ödeme tamamlanınca bakiye otomatik güncellenecek.":
    "Die Zahlungsseite wurde geöffnet. Nach Abschluss der Zahlung wird das Guthaben automatisch aktualisiert.",
  "Tamamlanmayı bekleyen ödeme": "Ausstehende Zahlung",
  "Ödeme sekmesi açılmadıysa bağlantıyı buradan yeniden açabilirsiniz.":
    "Falls sich der Zahlungs-Tab nicht geöffnet hat, können Sie den Link hier erneut öffnen.",
  "Ödeme sayfasını aç": "Zahlungsseite öffnen",
  "Ödemeyi kontrol et": "Zahlung prüfen",
  "Checkout oluşturulamadı.": "Der Checkout konnte nicht erstellt werden.",
  "Ödeme henüz tamamlanmamış görünüyor.": "Die Zahlung ist offenbar noch nicht abgeschlossen.",
  "Ödeme doğrulandı ve etiketler bakiyeye eklendi.": "Die Zahlung wurde bestätigt und die Labels wurden dem Guthaben hinzugefügt.",
  "Ödeme kontrolü tamamlandı.": "Die Zahlungsprüfung wurde abgeschlossen.",
  "Ödeme doğrulanamadı.": "Die Zahlung konnte nicht bestätigt werden.",
  "Etiket kredilerini checkout ile satın alın; ödeme tamamlanınca bakiyeniz otomatik güncellenir.":
    "Kaufen Sie Label-Guthaben über den Checkout; nach Abschluss der Zahlung wird Ihr Guthaben automatisch aktualisiert.",
  "Mevcut": "Vorhanden",
  "Satır brutto": "Brutto pro Position",
  "adet.": "Stück.",
  "Ürünlerden miktar girerek sepete satır ekleyin.": "Geben Sie Produktmengen ein und fügen Sie die Positionen dem Warenkorb hinzu.",
  "Ara toplam netto": "Zwischensumme netto",
  "stok sınırını aşıyor.": "überschreitet den Lagerbestand.",
  "Ödemeye geç": "Zur Kasse",
  "Şifreyi göster": "Passwort anzeigen",
  "Şifreyi gizle": "Passwort ausblenden",
  "Süresi Bitmiş Etiketler": "Abgelaufene Labels",
  "Genel bakış": "Übersicht",
  "Alt müşteri çalışma alanı": "Arbeitsbereich für Unterkunden",
  "Müşteri çalışma alanı": "Kundenarbeitsbereich",
  "Son sipariş, gönderi, etiket alımı ve fatura kayıtları burada görünecek":
    "Letzte Bestellungen, Sendungen, Labelkäufe und Rechnungen werden hier angezeigt",
  "Raporlar hazır": "Berichte sind bereit",
  "Yeni veri geldikçe dashboard otomatik dolacak": "Das Dashboard wird bei neuen Daten automatisch aktualisiert",
  "İlk sipariş veya etiket oluşturulduğunda burada görünecek": "Die erste Bestellung oder das erste Label wird hier angezeigt",
  "Panel hazır": "Kundenbereich ist bereit",
  "Mağaza, sipariş, etiket ve fatura hareketleri takip edilecek": "Shop-, Bestell-, Label- und Rechnungsaktivitäten werden hier verfolgt",
  "Yeni sürüm hazır": "Neue Version verfügbar",
  "Sayfa eski önbellekten çalışıyor olabilir. Güncel etiket penceresi için sayfayı yenileyin.":
    "Die Seite verwendet möglicherweise noch eine ältere Cache-Version. Aktualisieren Sie die Seite, um die neueste Version zu laden.",
  "sayfa": "Seite",
  "Oluşturulma": "Erstellt",
  "Güncelleme": "Aktualisiert",
  "Gönderim": "Versendet am",
  "Listeyi yenile": "Liste aktualisieren",
  "Takibi yenile": "Tracking aktualisieren",
  "Sil": "Löschen",
  "Pasif": "Inaktiv",
  "olarak müşteri panelindesiniz.": "– Kundenansicht aktiv.",
  "Takip geri yazma": "Trackingnummer zurückmelden",
  "Kaydet": "Speichern",
  "Sıfırla": "Zurücksetzen",
  "Profildeki genel gönderici adresi": "Allgemeine Absenderadresse aus dem Profil",
  "Senkron durumu": "Synchronisierungsstatus",
  "Etikette SKU": "SKU auf dem Label",
  "Eski sistemdeki temel store ayarları ve platform credential bilgileri.":
    "Grundlegende Shop-Einstellungen und Plattform-Zugangsdaten aus dem bisherigen System.",
  "Kontrol": "Prüfung",
  "Başlangıç": "Beginn",
  "Etiket bakiyesi": "Label-Guthaben",
  "Mağazalara git": "Zu den Shops",
  "Plan ve etiket satın alma durumu.": "Plan- und Labelkaufstatus.",
  "KenPost operasyon verisi": "KenPost-Betriebsdaten",
  "Final eşitleme": "Abschließende Synchronisierung",
  "Etiket paketleri": "Labelpakete",
  "Etiket indirme": "Labels herunterladen",
  "Almanca etiket indirme ve çıktı alma adımları.":
    "Schritte zum Herunterladen und Drucken von Labels auf Deutsch.",
  "Manuel etiket oluşturma": "Manuelle Label-Erstellung",
  "Almanya içi manuel adres ve etiket oluşturma akışı.":
    "Ablauf für manuelle Adressen und Labels innerhalb Deutschlands.",
  "Mağaza bağlantıları": "Shop-Verbindungen",
  "Shopify, eBay ve diğer pazar yerleri için bağlantı adımları.":
    "Verbindungsschritte für Shopify, eBay und weitere Marktplätze.",
  "Toplu işlem": "Sammelverarbeitung",
  "CSV/XLSX ile çoklu gönderi hazırlama ve sonuç kontrolü.":
    "Mehrere Sendungen per CSV/XLSX vorbereiten und die Ergebnisse prüfen.",
  "Toplam gönderi": "Sendungen insgesamt",
  "Etiket bakiyeleri raporu": "Bericht zu Label-Guthaben",
  "Ürün/kg bazında mevcut bakiye, son kullanım ve kritik stok.":
    "Aktuelles Guthaben, letzte Nutzung und kritischer Bestand nach Produkt/Gewicht.",
  "Toplam mevcut": "Gesamt verfügbar",
  "Son 30 gün kullanım": "Nutzung der letzten 30 Tage",
  "Kritik ürün": "Kritisches Produkt",
  "Son kullanım": "Letzte Nutzung",
  "Tahmini kalan gün": "Geschätzte Resttage",
  "İade, carrier hatası, label ve takip senkronu sorunları.":
    "Retouren, Carrier-Fehler, Label- und Tracking-Synchronisierungsprobleme.",
  "Sorunlu gönderi": "Problematische Sendungen",
  "Takip senkron hatası": "Fehler bei der Tracking-Synchronisierung",
  "Label üretim hatası": "Fehler bei der Label-Erstellung",
  "Sorun tipi": "Problemtyp",
  "Carrier mesajı": "Carrier-Meldung",
  "Rapor yükleniyor": "Bericht wird geladen",
  "Satın alınan etiket": "Gekaufte Labels",
  "Toplam tutar": "Gesamtbetrag",
  "Net tutar": "Nettobetrag",
  "Adet": "Anzahl",
  "Not": "Hinweis",
  "Yazdırılan": "Gedruckt",
  "Takip başarılı": "Tracking erfolgreich",
  "Takip bekleyen": "Tracking ausstehend",
  "Carrier hata": "Carrier-Fehler",
  "disabled": "Deaktiviert",
  "Alıcı": "Empfänger",
  "Etiket ürünü": "Labelprodukt",
  "Etiket sağlayıcı": "Labelanbieter",
  "Yazdırılma/Gönderim": "Gedruckt/versendet am",
  "Takip mesajı": "Tracking-Meldung",
  "Takip zamanı": "Tracking-Zeitpunkt",
  "Taşıyıcı": "Versanddienstleister",
  "DHL teslimat durumu": "DHL-Sendungsstatus",
  "Gönderi bilgisi": "Sendungsinformationen",
  "Kaynak platform senkronu": "Synchronisierung mit der Quellplattform",
  "Takip no": "Trackingnummer",
  "Gönderi tipi": "Sendungstyp",
  "Adres kaynağı": "Adressquelle",
  "Shopify gönderim durumu": "Shopify-Fulfillmentstatus",
  "Shopify mesajı": "Shopify-Meldung",
  "Ağırlık aralığı": "Gewichtsbereich",
  "Gönderilere dön": "Zurück zu den Sendungen",
  "Takip senkronu": "Tracking synchronisieren",
  "DHL event": "DHL-Ereignis",
  "Gönderi detayı açılamadı": "Die Sendungsdetails konnten nicht geöffnet werden",
  "Gönderi detayı yükleniyor": "Sendungsdetails werden geladen",
  "Gönderi bulunamadı": "Sendung nicht gefunden",
  "ZIP paket": "ZIP-Paket",
  "Retoure / iade": "Retoure",
  "CSV dışa aktar": "CSV exportieren",
  "Ağırlık gr": "Gewicht (g)",
  "CSV indir": "CSV herunterladen",
  "Excel indir": "Excel herunterladen",
  "En eski tarih": "Ältestes Datum",
  "manual": "Manuell",
  "jtl": "JTL",
  "JTL_IP": "JTL (IP/Datenbank)",
  "The tracking result looked open, but this label is already consumed by a shipment in Kenpost. It is therefore kept as used. This label was already consumed in inventory, so only the carrier audit was updated.":
    "Das Tracking-Ergebnis wirkte offen, dieses Label wurde jedoch bereits von einer KenPost-Sendung verwendet. Es bleibt daher als verwendet markiert. Da es bereits aus dem Bestand verbraucht wurde, wurde nur die Carrier-Prüfung aktualisiert.",
  "shipped": "Versendet",
  "paid": "Bezahlt",
  "open": "Offen",
  "success": "Erfolgreich",
  "pending": "Ausstehend",
  "completed": "Abgeschlossen",
  "active": "Aktiv",
  "inactive": "Inaktiv",
  "available": "Verfügbar",
  "printed": "Gedruckt",
  "failed": "Fehlgeschlagen",
  "error": "Fehler",
  "cancelled": "Storniert",
  "canceled": "Storniert",
  "expired": "Abgelaufen",
  "disconnected": "Getrennt",
  "void": "Storniert",
  "Kendi yazılımınızdan KenPost etiketi oluşturun ve sonuçları güvenle alın.": "Erstellen Sie KenPost-Labels aus Ihrer eigenen Software und rufen Sie die Ergebnisse sicher ab.",
  "API key oluştur": "API-Schlüssel erstellen",
  "anahtar": "Schlüssel",
  "Kopyala": "Kopieren",
  "Panoya kopyalandı.": "In die Zwischenablage kopiert.",
  "API anahtarı oluşturuldu. Şimdi güvenli bir yere kaydedin.": "Der API-Schlüssel wurde erstellt. Speichern Sie ihn jetzt an einem sicheren Ort.",
  "API anahtarı iptal edildi.": "Der API-Schlüssel wurde widerrufen.",
  "Yeni API anahtarınız": "Ihr neuer API-Schlüssel",
  "Bu değer yalnızca bir kez gösterilir. Şimdi kopyalayıp parola kasanıza kaydedin.": "Dieser Wert wird nur einmal angezeigt. Kopieren Sie ihn jetzt in Ihren Passwortmanager.",
  "Anahtarı kopyala": "Schlüssel kopieren",
  "Kopyalandı": "Kopiert",
  "Güvenli erişim": "Sicherer Zugriff",
  "Anahtarlar yalnızca bir kez gösterilir ve KenPost'ta geri okunamaz. Her anahtarı ayrı yetki, IP ve son kullanma tarihiyle sınırlandırabilirsiniz.": "Schlüssel werden nur einmal angezeigt und können in KenPost nicht erneut ausgelesen werden. Jeder Schlüssel kann nach Berechtigung, IP-Adresse und Ablaufdatum eingeschränkt werden.",
  "Anahtarlar yalnızca bir kez gösterilir ve KenPost'ta geri okunamaz. Her anahtarı ayrı yetki, IP, son kullanma tarihi ve günlük etiket kotasıyla sınırlandırabilirsiniz.": "Schlüssel werden nur einmal angezeigt und können in KenPost nicht erneut ausgelesen werden. Jeder Schlüssel kann nach Berechtigung, IP-Adresse, Ablaufdatum und täglichem Label-Kontingent eingeschränkt werden.",
  "Tekrarsız işlem": "Duplikatsichere Anfragen",
  "Etiket oluştururken": "Beim Erstellen eines Labels ist",
  "zorunludur. Ağ hatasında aynı istek tekrar edilse bile ikinci kredi harcanmaz.": "erforderlich. Wird dieselbe Anfrage nach einem Netzwerkfehler wiederholt, wird kein zweites Guthaben verbraucht.",
  "Sunucudan sunucuya": "Server-zu-Server",
  "API yalnızca arka uç yazılımları içindir. Mağaza bağlama ve entegrasyon ayarları güvenlik nedeniyle müşteri panelinde kalır.": "Die API ist nur für Backend-Software vorgesehen. Shop-Verbindungen und Integrationseinstellungen bleiben aus Sicherheitsgründen im Kundenpanel.",
  "API anahtarları": "API-Schlüssel",
  "Son kullanım ve istek sayıları burada izlenir.": "Letzte Verwendung und Anzahl der Anfragen werden hier angezeigt.",
  "Anahtarlar yükleniyor": "Schlüssel werden geladen",
  "Son kullanım:": "Letzte Verwendung:",
  "Son IP:": "Letzte IP:",
  "30 günlük istek:": "Anfragen in 30 Tagen:",
  "Hız sınırı:": "Ratenlimit:",
  "Etiket kotası:": "Label-Kontingent:",
  "Oluşturma:": "Erstellt:",
  "Son kullanma:": "Gültig bis:",
  "IP kısıtı:": "IP-Einschränkung:",
  "İptal et": "Widerrufen",
  "Henüz API anahtarı yok.": "Noch keine API-Schlüssel vorhanden.",
  "İlk entegrasyonunuz için ayrı bir anahtar oluşturun.": "Erstellen Sie einen separaten Schlüssel für Ihre erste Integration.",
  "API dokümantasyonu": "API-Dokumentation",
  "Sürüm 1 · Temel adres:": "Version 1 · Basis-URL:",
  "OpenAPI indir": "OpenAPI herunterladen",
  "Tüm isteklerde": "Verwenden Sie bei jeder Anfrage den Header",
  "başlığı kullanılır. Anahtarı URL'ye, tarayıcı koduna veya loglara yazmayın.": ". Schreiben Sie den Schlüssel niemals in eine URL, Browsercode oder Protokolle.",
  "Metot": "Methode",
  "Uç": "Endpunkt",
  "Yetki": "Berechtigung",
  "Açıklama": "Beschreibung",
  "Hesap ve gönderici hazırlığı": "Konto- und Absenderbereitschaft",
  "Desteklenen özellikler": "Unterstützte Funktionen",
  "Etiket ürünleri": "Labelprodukte",
  "Kullanılabilir krediler": "Verfügbares Guthaben",
  "Bağlı mağazalar (salt okunur)": "Verbundene Shops (schreibgeschützt)",
  "Kredi harcamadan doğrulama": "Prüfung ohne Guthabenverbrauch",
  "Etiket oluşturma": "Label erstellen",
  "API etiketlerini listeleme": "API-Labels auflisten",
  "Etiket durumu ve takip no": "Labelstatus und Trackingnummer",
  "Etiket PDF'i": "Label-PDF",
  "Etiket oluşturma örneği": "Beispiel zum Erstellen eines Labels",
  "cURL örneği kopyalandı.": "cURL-Beispiel kopiert.",
  "Başarılı yanıt": "Erfolgreiche Antwort",
  "Standart hata": "Standardfehler",
  "Her etiket isteğinde sipariş ve paket için benzersiz bir anahtar gönderin. Aynı anahtar ve aynı gövde güvenle tekrar edilebilir.": "Senden Sie für jede Labelanfrage einen eindeutigen Schlüssel pro Bestellung und Paket. Derselbe Schlüssel und derselbe Inhalt können sicher erneut gesendet werden.",
  "Hız sınırı": "Ratenlimit",
  "Katmanlı hız sınırı": "Mehrstufiges Ratenlimit",
  "Anahtar, hesap ve etiket oluşturma limitlerinden biri aşılırsa": "Wird ein Schlüssel-, Konto- oder Label-Erstellungslimit überschritten, gibt die API",
  "kadar bekleyin; otomatik tekrarlar için gecikmeyi kademeli artırın.": "Warten Sie vor dem erneuten Versuch entsprechend lange und erhöhen Sie die Verzögerung bei automatischen Wiederholungen schrittweise.",
  "Aşıldığında": "Bei Überschreitung gibt die API",
  "döner.": "zurück. Beachten Sie den",
  "başlığını izleyerek tekrar deneyin.": "Header, bevor Sie es erneut versuchen.",
  "Veri sınırı": "Datenzugriff",
  "Gönderici adresi paneldeki doğrulanmış profilden gelir. API, mağaza bağlantısı ekleyemez veya değiştiremez.": "Die Absenderadresse stammt aus dem verifizierten Profil im Panel. Die API kann keine Shop-Verbindungen hinzufügen oder ändern.",
  "addresses ile iki adresi etiket bazında belirleyebilirsiniz. Bu alan gönderilmezse mevcut profil adresi kullanılır. API, hesap profilini veya mağaza bağlantılarını değiştirmez.": "Mit addresses können Sie beide Adressen je Label festlegen. Ohne dieses Feld wird die bisherige Profiladresse verwendet. Die API verändert weder das Kontoprofil noch Shop-Verbindungen.",
  "Yeni API key": "Neuer API-Schlüssel",
  "Her uygulama veya sunucu için ayrı anahtar oluşturmanız önerilir.": "Wir empfehlen einen separaten Schlüssel für jede Anwendung oder jeden Server.",
  "Anahtar adı": "Schlüsselname",
  "Örn. Depo yazılımı": "z. B. Lager-Software",
  "Yetkiler": "Berechtigungen",
  "Son kullanma tarihi (isteğe bağlı)": "Ablaufdatum (optional)",
  "Dakikalık istek sınırı": "Anfragen pro Minute",
  "Günlük etiket sınırı": "Tägliches Label-Limit",
  "Anahtar sınırı": "Schlüssellimit",
  "Ayarlanan değer / dakika": "Konfigurierter Wert / Minute",
  "Etiket dakika sınırı": "Label-Ratenlimit",
  "Günlük etiket kotası": "Tägliches Label-Kontingent",
  "Anahtar başına ayarlanır": "Pro Schlüssel konfigurierbar",
  "Hesap güvenlik tavanı": "Sicherheitsobergrenze des Kontos",
  "Birden çok anahtar kullanılsa bile hesap genelinde aşılmaz.": "Die kontoübergreifende Obergrenze kann auch mit mehreren Schlüsseln nicht überschritten werden.",
  "İzinli IP adresleri (isteğe bağlı)": "Zulässige IP-Adressen (optional)",
  "Boş bırakırsanız tüm IP adresleri kullanılabilir. Sabit sunucu IP'lerini virgülle ayırın.": "Leer lassen, um alle IP-Adressen zuzulassen. Trennen Sie feste Server-IP-Adressen durch Kommas.",
  "Vazgeç": "Abbrechen",
  "Anahtarı oluştur": "Schlüssel erstellen",
  "Hesap bilgisi": "Kontodaten",
  "Bakiyeler": "Guthaben",
  "Mağazalar": "Shops",
  "Adres doğrulama": "Adressprüfung",
  "Etiket okuma": "Labels lesen",
  "API anahtarı yalnızca hesap sahibinin kendi oturumunda oluşturulabilir.": "Ein API-Schlüssel kann nur in der eigenen Sitzung des Kontoinhabers erstellt werden.",
  "API anahtarı yalnızca hesap sahibinin kendi oturumunda oluşturulabilir veya iptal edilebilir.": "API-Schlüssel können nur in der eigenen Sitzung des Kontoinhabers erstellt oder widerrufen werden.",
  "Hesap ve gönderici hazırlık durumunu okur.": "Liest den Bereitschaftsstatus von Konto und Absender.",
  "Kullanılabilir ürünleri ve ağırlıkları okur.": "Liest verfügbare Produkte und Gewichtsbereiche.",
  "Etiket kredilerini okur.": "Liest das Label-Guthaben.",
  "Bağlı mağazaları ve senkron durumunu salt okunur görüntüler.": "Liest verbundene Shops und deren Synchronisierungsstatus.",
  "Kredi harcamadan etiket isteğini kontrol eder.": "Prüft eine Labelanfrage ohne Guthabenverbrauch.",
  "Manuel krediden yeni etiket oluşturur.": "Erstellt ein neues Label aus manuellem Guthaben.",
  "API etiketlerini ve PDF dosyalarını okur.": "Liest API-Labels und PDF-Dateien.",
};

export type CustomerGermanTranslationPattern = {
  pattern: RegExp;
  replace: (match: RegExpMatchArray) => string;
};

export const customerGermanTranslationPatterns: CustomerGermanTranslationPattern[] = [
  {
    pattern: /^(\d+) etiket bakiyenize eklendi\. Kullanılan kazanç: (.+)\.$/,
    replace: (match) => `${match[1]} Labels wurden Ihrem Guthaben hinzugefügt. Verwendetes Guthaben: ${match[2]}.`,
  },
  { pattern: /^(.+?) mağazası bağla$/, replace: (match) => `${match[1]}-Shop verbinden` },
  { pattern: /^(.+?) sipariş detayını aç$/, replace: (match) => `Bestelldetails für ${match[1]} öffnen` },
  { pattern: /^(.+?) gönderisini iptal et$/, replace: (match) => `Sendung für ${match[1]} stornieren` },
  { pattern: /^(.+?) için etiket oluştur$/, replace: (match) => `Label für ${match[1]} erstellen` },
  { pattern: /^(.+?) etiketi indir$/, replace: (match) => `Label für ${match[1]} herunterladen` },
  {
    pattern: /^(.+?) siparişini arşivden geri al$/,
    replace: (match) => `Bestellung ${match[1]} aus dem Archiv wiederherstellen`,
  },
  { pattern: /^(.+?) siparişini arşivle$/, replace: (match) => `Bestellung ${match[1]} archivieren` },
  { pattern: /^(.+?) siparişini seç$/, replace: (match) => `Bestellung ${match[1]} auswählen` },
  { pattern: /^(.+?) gönderisini seç$/, replace: (match) => `Sendung ${match[1]} auswählen` },
  { pattern: /^(\d{8,}) seç$/, replace: (match) => `${match[1]} auswählen` },
  {
    pattern: /^([\d.,]+) items? ürün detayları$/,
    replace: (match) => `Artikeldetails für ${match[1]} Artikel`,
  },
  {
    pattern: /^(?=.* - Birim [^·]+ · Toplam [\d.,]+).+$/,
    replace: (match) =>
      match[0].replace(
        / - Birim ([^·]+?) · Toplam ([\d.,]+(?:\s*(?:€|£|\$|[A-Z]{3}))?)/g,
        " – Stückpreis $1 · Gesamt $2",
      ),
  },
  { pattern: /^(.+?) miktarını azalt$/, replace: (match) => `Menge für ${match[1]} verringern` },
  { pattern: /^(.+?) miktarını artır$/, replace: (match) => `Menge für ${match[1]} erhöhen` },
  {
    pattern: /^(.+? · )([\d.,]+) sipariş$/,
    replace: (match) => `${match[1]}${match[2]} Bestellungen`,
  },
  { pattern: /^([\d.,]+) sipariş$/, replace: (match) => `${match[1]} Bestellungen` },
  {
    pattern: /^([\d.,]+) aktif mağazada sipariş senkronu çalışmış görünüyor\.$/,
    replace: (match) =>
      match[1] === "1"
        ? "In 1 aktivem Shop wurde die Bestellsynchronisierung ausgeführt."
        : `In ${match[1]} aktiven Shops wurde die Bestellsynchronisierung ausgeführt.`,
  },
  {
    pattern: /^([\d.,]+) mağaza bağlı\.$/,
    replace: (match) => (match[1] === "1" ? "1 Shop verbunden." : `${match[1]} Shops verbunden.`),
  },
  {
    pattern: /^([\d.,]+) sipariş görünüyor\.$/,
    replace: (match) => (match[1] === "1" ? "1 Bestellung sichtbar." : `${match[1]} Bestellungen sichtbar.`),
  },
  {
    pattern: /^([\d.,]+) kullanılabilir etiket\.$/,
    replace: (match) => (match[1] === "1" ? "1 Label verfügbar." : `${match[1]} Labels verfügbar.`),
  },
  {
    pattern: /^([\d.,]+) ürün için kalan etiket kredileri\.$/,
    replace: (match) =>
      match[1] === "1"
        ? "Verbleibendes Label-Guthaben für 1 Produkt."
        : `Verbleibendes Label-Guthaben für ${match[1]} Produkte.`,
  },
  {
    pattern: /^([\d.,]+) (.+?) siparisi senkronlandi\.$/,
    replace: (match) => `${match[1]} ${match[2]}-Bestellungen synchronisiert.`,
  },
  {
    pattern: /^Yeni ([\d.,]+), güncellenen ([\d.,]+)(?: · Aralık (.+))?$/,
    replace: (match) => {
      const range = match[3]?.replace(/^(\d+) gün$/, "$1 Tage");
      return `Neu: ${match[1]}, aktualisiert: ${match[2]}${range ? ` · Zeitraum: ${range}` : ""}`;
    },
  },
  { pattern: /^([\d.,]+) sn$/, replace: (match) => `${match[1]} Sek.` },
  { pattern: /^(\d+) dk (\d+) sn$/, replace: (match) => `${match[1]} Min. ${match[2]} Sek.` },
  {
    pattern: /^Seçili takipleri senkronla \((\d+)\)$/,
    replace: (match) => `Ausgewählte Trackingnummern synchronisieren (${match[1]})`,
  },
  {
    pattern: /^DHL reports shipment activity \((.+)\)\. This label was already consumed in inventory, so only the carrier audit was updated\.$/,
    replace: (match) =>
      `DHL meldet eine Sendungsbewegung (${match[1]}). Dieses Label wurde bereits im Bestand verbraucht; daher wurde nur die Carrier-Prüfung aktualisiert.`,
  },
  { pattern: /^(\d+) konu takip bekliyor\.$/, replace: (match) => `${match[1]} Vorgänge warten auf Prüfung.` },
  {
    pattern: /^Toplam: ([\d.,]+|\.{3}) · Kullanıldı: ([\d.,]+|\.{3}) · Void: ([\d.,]+|\.{3})$/,
    replace: (match) => `Gesamt: ${match[1]} · Verwendet: ${match[2]} · Storniert: ${match[3]}`,
  },
  {
    pattern: /^(\d+) DHL gönderisi izleniyor; (\d+) kayıt müdahale listesinde\.$/,
    replace: (match) => `${match[1]} DHL-Sendungen werden überwacht; ${match[2]} Datensätze erfordern eine Prüfung.`,
  },
  { pattern: /^(\d+) günlük DHL etiketi$/, replace: (match) => `DHL-Labels der letzten ${match[1]} Tage` },
  { pattern: /^(\d+) gönderi$/, replace: (match) => `${match[1]} Sendungen` },
  { pattern: /^(\d+) günü aşan kayıt$/, replace: (match) => `Datensätze älter als ${match[1]} Tage` },
  { pattern: /^(\d+)\/(\d+) başarılı$/, replace: (match) => `${match[1]}/${match[2]} erfolgreich` },
  {
    pattern: /^Bugün ilgilenmen gereken (\d+) gönderi var$/,
    replace: (match) => `Heute müssen ${match[1]} Sendungen geprüft werden`,
  },
  {
    pattern: /^(\d+) ilk scan almadı, (\d+) gönderi riskte\.$/,
    replace: (match) => `${match[1]} ohne ersten Scan, ${match[2]} Sendungen gefährdet.`,
  },
  { pattern: /^(\d+) gönderide exception sinyali var$/, replace: (match) => `${match[1]} Sendungen weisen ein Ausnahmesignal auf` },
  { pattern: /^(\d+) kayıt başarı dışında\.$/, replace: (match) => `${match[1]} Datensätze sind nicht erfolgreich.` },
  {
    pattern: /^(\d+) çıkan · (\d+) sorun · (\d+) iade$/,
    replace: (match) => `${match[1]} versendet · ${match[2]} problematisch · ${match[3]} Retouren`,
  },
  { pattern: /^(\d+) kayıt gösteriliyor\.$/, replace: (match) => `${match[1]} Datensätze werden angezeigt.` },
  {
    pattern: /^(\d+)-(\d+) \/ ([\d.]+) kayıt$/,
    replace: (match) => `${match[1]}–${match[2]} von ${match[3]} Datensätzen`,
  },
  {
    pattern: /^([\d.]+) kayıt içinde (\d+)-(\d+) aralığı gösteriliyor\. (\d+) müsait etiket seçili\.$/,
    replace: (match) => `${match[2]}–${match[3]} von ${match[1]} Datensätzen werden angezeigt. ${match[4]} verfügbare Labels ausgewählt.`,
  },
  {
    pattern: /^([\d.]+) kayıttan (\d+)-(\d+) gösteriliyor\.$/,
    replace: (match) => `${match[2]}–${match[3]} von ${match[1]} Datensätzen werden angezeigt.`,
  },
  {
    pattern: /^(.+?) hesabı için fatura, gönderici, güvenlik ve şifre ayarları\.$/,
    replace: (match) => `Rechnungs-, Absender-, Sicherheits- und Passworteinstellungen für ${match[1]}.`,
  },
  {
    pattern: /^(\d+) gönderilik son toplu paketi tekrar indirebilirsiniz\.$/,
    replace: (match) => `Sie können das letzte Sammelpaket mit ${match[1]} Sendungen erneut herunterladen.`,
  },
  {
    pattern: /^(\d+) etiketi tek PDF olarak tekrar indirebilirsiniz\.$/,
    replace: (match) => `Sie können die letzten ${match[1]} Labels erneut als eine einzige PDF-Datei herunterladen.`,
  },
  {
    pattern: /^(\d+) etiket tek PDF olarak indirildi\.$/,
    replace: (match) => `${match[1]} Labels wurden als eine einzige PDF-Datei heruntergeladen.`,
  },
  {
    pattern: /^(\d+) etiket tek PDF dosyası olarak indirildi\.$/,
    replace: (match) => `${match[1]} Labels wurden als eine einzige PDF-Datei heruntergeladen.`,
  },
  {
    pattern: /^(\d+) filtrelenmiş gönderinin tamamı seçildi\.$/,
    replace: (match) => `Alle ${match[1]} gefilterten Sendungen wurden ausgewählt.`,
  },
  {
    pattern: /^(\d+) indirilebilir aktif gönderi seçildi; (\d+) uygun olmayan kayıt atlandı\.$/,
    replace: (match) => `${match[1]} aktive Sendungen mit herunterladbarem Label wurden ausgewählt; ${match[2]} ungeeignete Einträge wurden übersprungen.`,
  },
  {
    pattern: /^(\d+) filtrelenmiş sonuçtan tek PDF güvenlik sınırı olan ilk (\d+) indirilebilir gönderi seçildi\.$/,
    replace: (match) => `Von ${match[1]} gefilterten Ergebnissen wurden die ersten ${match[2]} herunterladbaren Sendungen bis zum Sicherheitslimit einer PDF-Datei ausgewählt.`,
  },
  {
    pattern: /^Seçili tek PDF indir \((\d+)\)$/,
    replace: (match) => `Auswahl als eine PDF herunterladen (${match[1]})`,
  },
  {
    pattern: /^Tek PDF hazırlanıyor \((\d+)\/(\d+)\)$/,
    replace: (match) => `Eine PDF-Datei wird erstellt (${match[1]}/${match[2]})`,
  },
  {
    pattern: /^(\d+) \/ (\d+) etiket PDF'e ekleniyor\. Sistem 50'şer adımlık güvenli parçalar halinde çalışıyor\.$/,
    replace: (match) => `${match[1]} / ${match[2]} Labels werden zur PDF hinzugefügt. Die Verarbeitung erfolgt intern in sicheren 50er-Schritten.`,
  },
  {
    pattern: /^(\d+) \/ (\d+) sipariş güvenli gruplar halinde işleniyor\. Pencereyi kapatmayın\.$/,
    replace: (match) => `${match[1]} / ${match[2]} Bestellungen werden in sicheren Gruppen verarbeitet. Schließen Sie das Fenster nicht.`,
  },
  {
    pattern: /^(\d+) etiket oluşturuldu, (\d+) mevcut gönderi atlandı, (\d+) hata\.(?: (\d+) sipariş otomatik arşivlendi\.)?(?: (\d+) yarım kalmış etiket PDF'i otomatik tamamlandı\.)?(?: (\d+) etiket tek PDF olarak indirildi\.)?$/,
    replace: (match) =>
      `${match[1]} Labels erstellt, ${match[2]} vorhandene Sendungen übersprungen, ${match[3]} Fehler.` +
      (match[4] ? ` ${match[4]} Bestellungen wurden automatisch archiviert.` : "") +
      (match[5] ? ` ${match[5]} unterbrochene Label-PDFs wurden automatisch fertiggestellt.` : "") +
      (match[6] ? ` ${match[6]} Labels wurden als eine einzige PDF-Datei heruntergeladen.` : ""),
  },
  {
    pattern: /^(\d+) etiket PDF'i henüz hazır olmadığı için eksik toplu PDF indirilmedi\. Son toplu işlemden yeniden deneyin\.$/,
    replace: (match) => `${match[1]} Label-PDFs sind noch nicht bereit; daher wurde keine unvollständige Sammel-PDF heruntergeladen. Versuchen Sie es über den letzten Sammelvorgang erneut.`,
  },
  {
    pattern: /^Tek PDF içinde en fazla (\d+) etiket indirilebilir\.$/,
    replace: (match) => `Eine PDF-Datei darf höchstens ${match[1]} Labels enthalten.`,
  },
  { pattern: /^(\d+) sipariş seçildi$/, replace: (match) => `${match[1]} Bestellungen ausgewählt` },
  { pattern: /^(\d+) sipariş ana listeden kaldırılacak\.$/, replace: (match) => `${match[1]} Bestellungen werden aus der Hauptliste entfernt.` },
  {
    pattern: /^(\d+) sipariş arşivlendi\.(?: (\d+) sipariş zaten arşivdeydi veya erişilebilir değildi\.)?$/,
    replace: (match) =>
      `${match[1]} Bestellungen archiviert.` +
      (match[2] ? ` ${match[2]} Bestellungen waren bereits archiviert oder nicht zugänglich.` : ""),
  },
  {
    pattern: /^Tek toplu arşiv işleminde en fazla (\d+) sipariş seçilebilir\.$/,
    replace: (match) => `Für eine Sammelarchivierung können höchstens ${match[1]} Bestellungen ausgewählt werden.`,
  },
  {
    pattern: /^Güvenli işlem sınırı nedeniyle en fazla (\d+) sipariş seçildi\.$/,
    replace: (match) => `Aufgrund des sicheren Verarbeitungslimits wurden höchstens ${match[1]} Bestellungen ausgewählt.`,
  },
  {
    pattern: /^(\d+) sipariş hazır\. En fazla (\d+) sipariş tek toplu işlemde sıraya alınır\.$/,
    replace: (match) => `${match[1]} Bestellungen sind bereit. Pro Sammelvorgang werden höchstens ${match[2]} Bestellungen eingeplant.`,
  },
  {
    pattern: /^(\d+) etiket (\d+) PDF dosyası olarak indirildi\.$/,
    replace: (match) => `${match[1]} Labels wurden als ${match[2]} PDF-Dateien heruntergeladen.`,
  },
  {
    pattern: /^(\d+) etiketi PDF dosyaları olarak tekrar indirebilirsiniz\.$/,
    replace: (match) => `Sie können ${match[1]} Labels erneut als PDF-Dateien herunterladen.`,
  },
  { pattern: /^(\d+) adet\.$/, replace: (match) => `${match[1]} Stück.` },
  { pattern: /^(\d+) stok sınırını aşıyor\.$/, replace: (match) => `Überschreitet den Lagerbestand von ${match[1]}.` },
  { pattern: /^Seçili iptal \((\d+)\)$/, replace: (match) => `Auswahl stornieren (${match[1]})` },
  { pattern: /^(\d+) teslim$/, replace: (match) => `${match[1]} zugestellt` },
  { pattern: /^(\d+) kargo$/, replace: (match) => `${match[1]} Sendungen` },
  { pattern: /^(.+?) · Tüm zamanlar: ([\d.,]+)$/, replace: (match) => `${match[1]} · Gesamt: ${match[2]}` },
  { pattern: /^Tüm zamanlar: ([\d.,]+)$/, replace: (match) => `Gesamt: ${match[1]}` },
  { pattern: /^(.+?) · printed$/, replace: (match) => `${match[1]} · Gedruckt` },
  { pattern: /^(.+?) · shipped$/, replace: (match) => `${match[1]} · Versendet` },
  { pattern: /^(.+?) · open$/, replace: (match) => `${match[1]} · Offen` },
  { pattern: /^(\d+) etiketi oluştur$/, replace: (match) => `${match[1]} Labels erstellen` },
  {
    pattern: /^(\d+) koli için (\d+) kredi gerekiyor; kullanılabilir kredi (\d+)\.$/,
    replace: (match) => `Für ${match[1]} Pakete werden ${match[2]} Guthaben benötigt; verfügbar sind ${match[3]}.`,
  },
];

export function translateCustomerGermanText(value: string) {
  const normalized = value.replace(/\s+/g, " ").trim();
  const direct = customerGermanTranslations[normalized];
  if (direct) return direct;
  for (const item of customerGermanTranslationPatterns) {
    const match = normalized.match(item.pattern);
    if (match) return item.replace(match);
  }
  return null;
}
